/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import $ from "jquery";

require('./bootstrap');
require('./jquery.responsivetabs');
require('./rating');

require('spectrum-colorpicker2/dist/spectrum');
require('jquery-mask-plugin');
require('jquery-ui/ui/widgets/autocomplete');
require('bootstrap-datepicker/dist/js/bootstrap-datepicker.min');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min');

import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

if (!Chart._annotationRegistered) {
    Chart.register(...registerables);
    Chart.register(annotationPlugin);
    Chart._annotationRegistered = true;
}

const Tagify = require('@yaireo/tagify');
const SignaturePad = require('signature_pad/dist/signature_pad.umd.min')

import Sortable from 'sortablejs';
import Swal from 'sweetalert2'
import * as moment from 'moment'
import autosize from "autosize/dist/autosize";
window.Vue = require('vue');

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad)

import { BootstrapVue } from 'bootstrap-vue'
import VueStash from 'vue-stash';
Vue.use(BootstrapVue)
Vue.use(VueStash);

import { BarcodeFormat, BrowserBarcodeReader, BrowserMultiFormatReader, DecodeHintType, NotFoundException } from '@zxing/library';

import GenericMultiSelect from './components/GenericMultiSelectComponent';
import QuoteAcceptance from "./components/trade/QuoteAcceptance";
import UsersStatistics from "./components/hr/UsersStatistics";
import TradeEvolution from "./components/trade/TradeEvolution";
import ContractsStatistics from "./components/hr/ContractsStatistics";
import ClientBalance from "./components/trade/ClientBalance";
import ProviderBalance from "./components/spending/ProviderBalance";
import DebtorsRank from "./components/trade/DebtorsRank";
import FiltersSummary from "./components/FiltersSummary";
import Comments from "./components/Comments";
import LineTableForm from "./components/trade/LineTableForm";
import LineForm from "./components/trade/LineForm";
import DiscountGridForm from "./components/settings/DiscountGridForm";
import ShippingGridForm from "./components/settings/ShippingGridForm";
import Sendings from "./components/Sendings";
import BonusSelector from "./components/hr/BonusSelector";
import UserSelector from './components/hr/UserSelector';
import ExpenseReportLineTableForm from "./components/spending/ExpenseReportLineTableForm";
import ExpenseReportLineForm from "./components/spending/ExpenseReportLineForm";
import Signatures from "./components/Signatures";
import SignaturesReceptions from "./components/SignaturesReceptions";
import DocumentsManagerModal from "./components/DocumentsManagerModal";
import DocumentsManager from "./components/DocumentsManager";
import BillPaymentOrderSelector from "./components/bank/BillPaymentOrderSelector";
import AbsencesTable from "./components/hr/AbsencesTable";
import ArticleProviderTableForm from "./components/stock/ArticleProviderTableForm";
import ArticleProviderForm from "./components/stock/ArticleProviderForm";
import ArticleKitComponentsTableForm from "./components/stock/ArticleKitComponentsTableForm";
import ArticleKitComponentForm from "./components/stock/ArticleKitComponentForm";
import ArticleKitPricingSummary from "./components/stock/ArticleKitPricingSummary";
import ArticlePriceRuleForm from "./components/stock/ArticlePriceRuleForm";
import CompanyPriceRuleModal from "./components/crm/CompanyPriceRuleModal";
import ArticleAttributeForm from "./components/stock/ArticleAttributeForm";
import PurchaseTableForm from "./components/spending/PurchaseTableForm";
import PurchaseForm from "./components/spending/PurchaseForm";
import ExpenseBillSelector from "./components/spending/ExpenseBillSelector";
import ArticleSelector from "./components/stock/ArticleSelector";
import CheckingForm from "./components/hr/CheckingForm";
import InitScanCheckingForm from "./components/hr/InitScanCheckingForm";
import CheckingsTable from "./components/hr/CheckingsTable";
import PrecheckingsTable from "./components/hr/PrecheckingsTable";
import PrecheckingsForm from "./components/hr/PrecheckingsForm";
import PredictionTableForm from "./components/trade/PredictionTableForm";
import EditPredictionTable from "./components/trade/EditPredictionTable";
import PredictionForm from "./components/trade/PredictionForm";
import VatsArray from "./components/VatsArray";
import CompanySelector from './components/crm/CompanySelector';
import CompanyPennylaneSync from './components/crm/CompanyPennylaneSync';
import InvoicePennylaneSync from './components/trade/InvoicePennylaneSync';
import CreditNotePennylaneSync from './components/trade/CreditNotePennylaneSync';
import InvoiceValidationModal from './components/trade/InvoiceValidationModal';
import AccountingAccountsAffectation from "./components/bank/AccountingAccountsAffectation";
import TasksTable from "./components/crm/TasksTable";
import SubtasksManager from "./components/crm/SubtasksManager";
import AccountingAccountGeneration from "./components/crm/AccountingAccountGeneration";
import QuickNote from "./components/QuickNote";
import UserNotification from './components/UserNotificationComponent';
import PriceForm from './components/trade/PriceForm';
import AbsencesTableModal from './components/hr/AbsencesTableModal';

import DeliveryLineForm from "./components/activity/DeliveryLineForm";
import DeliveryLineTableForm from "./components/activity/DeliveryLineTableForm";
import DealProgress from "./components/activity/DealProgress";
import OperationTableForm from "./components/activity/OperationTableForm";
import OperationForm from "./components/activity/OperationForm";
import SchedulesKanban from "./components/activity/SchedulesKanban";
import SchedulesSingle from "./components/activity/SchedulesSingle";

import IndicatorsArray from "./components/indicators/IndicatorsArray";

import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import VueUploadComponent from 'vue-upload-component'
import VCalendar from 'v-calendar';
Vue.use(VCalendar);

import Elements from "./components/form_elements/Elements";
import DisplayFormBuilder from "./components/DisplayFormBuilderComponent";
import RenderFormBuilder from './components/RenderFormBuilderComponent';
import PhoneNumber from './components/hr/PhoneNumber';
import BillTotalsForm from './components/spending/BillTotalsForm';
import DealLotOperation from './components/DealLotOperation';
import Note from './components/NoteComponent';
import CustomEditor from './components/CustomEditor';

import SpendingEvolution from "./components/spending/SpendingEvolution";
import BankEvolution from "./components/bank/BankEvolution";
import PaymentComponent from './components/bank/PaymentComponent';
import PayableLine from './components/bank/PayableLine';

import ActivityPies from "./components/activity/ActivityPies";
import Counter from './components/gmao/CounterComponent';
import TriggerComponent from './components/gmao/TriggerComponent';
import PlanningTable from './components/gmao/PlanningTable';
import FormPlanningComponent from './components/gmao/FormPlanningComponent';
import SyncOperation from './components/gmao/SyncOperation';
import CheckingMaintenanceForm from './components/gmao/CheckingMaintenanceForm';
import CreateInspectionComponent from './components/gmao/CreateInspectionComponent';
import PlanningTableModal from './components/gmao/PlanningTableModal';
import DealLotProgress from './components/activity/DealLotProgress';
import GroupOrders from './components/trade/GroupOrders';
import InjectStudy from './components/trade/InjectStudy';
import QuoteVersioning from './components/trade/QuoteVersioning';
import AcceptQuoteVersionning from './components/trade/AcceptQuoteVersionning';
import ServiceListTableForm from './components/trade/ServiceListTableForm';
import ServiceListForm from "./components/trade/ServiceListForm";
import BillCreditSupplierForm from './components/spending/BillCreditSupplierForm';
import BillInboxSidebar from './components/spending/BillInboxSidebar.vue';

import SendingModalComponent from './components/tools/SendingModalComponent';
import TradeStatistics from './components/trade/TradeStatistics';
import ChronoComponent from './components/ChronoComponent';
import DiscountTrade from "./components/trade/DiscountTrade.vue";

import 'leaflet/dist/leaflet.css';
import MapComponent from './components/gmao/MapComponent';
import GeolocationPicker from './components/GeolocationPicker';
import BookingLotArticleForm from "./components/activity/BookingLotArticleForm.vue";
import BookingArticleLine from "./components/activity/BookingArticleLine.vue";
import BookingLotArticleLine from "./components/activity/BookingLotArticleLine.vue";
import BookingModal from "./components/activity/BookingModal.vue";
import ArticleProgressStock from "./components/stock/ArticleProgressStock.vue";
import BookingArticleTable from "./components/stock/BookingArticleTable.vue";
import ArticleEcoTaxForm from "./components/stock/ArticleEcoTaxForm.vue";
import EmplacementSelector from "./components/stock/EmplacementSelector.vue";
import EmplacementTreeSelector from "./components/stock/EmplacementTreeSelector.vue";
import ArticleFamilySelector from "./components/stock/ArticleFamilySelector.vue";
import EmplacementTreeManager from "./components/stock/EmplacementTreeManager.vue";
import ArticleFamilyTreeManager from "./components/stock/ArticleFamilyTreeManager.vue";
import EmplacementArticlesManager from "./components/stock/EmplacementArticlesManager.vue";
import ArticleEmplacementsManager from "./components/stock/ArticleEmplacementsManager.vue";
import ArticleFamilyArticlesManager from "./components/stock/ArticleFamilyArticlesManager.vue";
import TreeMultiSelector from "./components/stock/TreeMultiSelector.vue";
import ArticleDealsSummary from "./components/stock/ArticleDealsSummary.vue";
import ArticleTradeStatsSummary from "./components/stock/ArticleTradeStatsSummary.vue";
import StockMovementTotals from "./components/stock/StockMovementTotals.vue";
import ReceptionsValuationSummary from "./components/spending/ReceptionsValuationSummary.vue";

import AutoFormSaveComponent from './components/AutoFormSaveComponent.vue';

import EquipmentStationTable from "./components/activity/EquipmentStationTable.vue";
import PrecheckingsInterventionForm from "./components/hr/PrecheckingsInterventionForm.vue";
import PrecheckingsInterventionTable from "./components/hr/PrecheckingsInterventionTable.vue";
import GroupDeliveries from "./components/activity/GroupDeliveries.vue";
import EmplacementCascadingFilter from "./components/stock/EmplacementCascadingFilter.vue";
import ArticleSerialNumberForm from "./components/stock/ArticleSerialNumberForm.vue";
import ArticleSerialNumberHistoryModal from "./components/stock/ArticleSerialNumberHistoryModal.vue";
import ArticleSerialNumberComponent from "./components/stock/ArticleSerialNumberComponent.vue";


import Fragment from 'vue-fragment';
Vue.use(Fragment.Plugin);

Vue.component('file-upload', VueUploadComponent);
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });
const API_TOKEN = document.head.querySelector("[name~=api-token][content]").content;
const CSRF_TOKEN = document.head.querySelector("[name~=csrf-token][content]").content;

const COLOR_PRIMARY = "#d9523b";
const COLOR_BLUE = "#077FD4";
const COLOR_LIGHT = "#F6F6F6";

window.addEventListener('pageshow', PageShowHandler, false);
window.addEventListener('unload', UnloadHandler, false);

moment.locale('fr');

function PageShowHandler() {
    window.addEventListener('unload', UnloadHandler, false);
}

function UnloadHandler() {
    window.removeEventListener('unload', UnloadHandler, false);
}

$(function () {

    // Masquer la colonne % si le type de facture n'est pas "Facture" (type 0)
    const initialType = $('#type').val();
    if (initialType && initialType != "0") {
        $('.percentage-field').hide();
    }

    // Mot de passe en clair (accès tiers)
    $('#show-btn-password span').on('click', function (e) {
        e.preventDefault();
        if ($('#show-btn-password input').attr('type') == 'text') {
            $('#show-btn-password input').attr('type', 'password');
            $('#show-btn-password i').addClass("fa-eye-slash");
            $('#show-btn-password i').removeClass("fa-eye");
        } else if ($('#show-btn-password input').attr('type') == 'password') {
            $('#show-btn-password input').attr('type', 'text');
            $('#show-btn-password i').addClass("fa-eye");
            $('#show-btn-password i').removeClass("fa-eye-slash");
        }
    });

    /**
     * Règles de mot de passe dynamiques
     *
     * HTML attendu :
     * <div class="js-password-rules" data-password-input="#password">
     *   <li class="password-rule" data-rule="length">...</li>
     *   <li class="password-rule" data-rule="lowercase">...</li>
     *   <li class="password-rule" data-rule="uppercase">...</li>
     *   <li class="password-rule" data-rule="number">...</li>
     *   <li class="password-rule" data-rule="special">...</li>
     * </div>
     */
    function initPasswordRules() {
        var $blocks = $('.js-password-rules');
        if ($blocks.length === 0) {
            return;
        }

        $blocks.each(function () {
            var $block = $(this);
            var selector = $block.data('password-input') || '#password';
            var $input = $(selector);

            if ($input.length === 0) {
                return;
            }

            var $rules = {
                length: $block.find('[data-rule="length"]'),
                lowercase: $block.find('[data-rule="lowercase"]'),
                uppercase: $block.find('[data-rule="uppercase"]'),
                number: $block.find('[data-rule="number"]'),
                special: $block.find('[data-rule="special"]'),
            };

            function updatePasswordRules() {
                var value = $input.val() || '';

                var length = value.length;
                var hasLowercase = /[a-z]/.test(value);
                var hasUppercase = /[A-Z]/.test(value);
                var hasNumber    = /[0-9]/.test(value);
                // Compatible tous navigateurs : on considère "spécial" = pas lettre ASCII ni chiffre
                var hasSpecial = /[!@#$%^&*()_\-+=[\]{};:'"\\|,.<>\/?]/.test(value);

                toggleRule($rules.length, length >= 12);
                toggleRule($rules.lowercase, hasLowercase);
                toggleRule($rules.uppercase, hasUppercase);
                toggleRule($rules.number, hasNumber);
                toggleRule($rules.special, hasSpecial);
            }

            function toggleRule($el, isValid) {
                if (!$el || $el.length === 0) {
                    return;
                }

                var $icon = $el.find('i').first();

                if (isValid) {
                    $el.removeClass('text-muted text-danger').addClass('text-success');
                    if ($icon.length) {
                        $icon.removeClass('fa-circle fa-times').addClass('fa-check');
                    }
                } else {
                    $el.removeClass('text-success text-danger').addClass('text-muted');
                    if ($icon.length) {
                        $icon.removeClass('fa-check fa-times').addClass('fa-circle');
                    }
                }
            }

            // Initialisation et écoute des changements
            updatePasswordRules();

            $input.on('input', updatePasswordRules);
        });
    }

    initPasswordRules();

    // Copie dans le presse-papiers lors du clic sur un élément texte
    // HTML attendu :
    // <span class="js-copy-on-click" data-copy-text="...">Texte à copier</span>
    $(document).on('click', '.js-copy-on-click', function () {
        var text = $(this).data('copy-text') || $(this).text();

        if (!text) {
            return;
        }

        function notify(message) {
            alert(message);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
                notify('Lien copié dans le presse-papiers');
            }).catch(function () {
                notify('Impossible de copier le lien automatiquement');
            });
        } else {
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val(text).select();
            try {
                document.execCommand('copy');
                notify('Lien copié dans le presse-papiers');
            } catch (e) {
                notify('Impossible de copier le lien automatiquement');
            }
            $temp.remove();
        }
    });

    // Mot de passe en clair (tous les champs avec .js-toggle-password dans un input-group)
    $('.js-toggle-password').on('click', function (e) {
        e.preventDefault();
        var $group = $(this).closest('.input-group');
        if ($group.length === 0) return;

        var $input = $group.find('input[type="password"], input[type="text"]').first();
        if ($input.length === 0) return;

        var $icon = $(this).find('i');

        if ($input.attr('type') === 'password') {
            $input.attr('type', 'text');
            if ($icon.length) {
                $icon.removeClass('fa-eye').addClass('fa-eye-slash');
            }
        } else {
            $input.attr('type', 'password');
            if ($icon.length) {
                $icon.removeClass('fa-eye-slash').addClass('fa-eye');
            }
        }
    });

    if($('#due_at').length > 0 && $('#payment_delay_id').length > 0 && $('#validated_at').length > 0 && $('#due_at').val() != null && $('#due_at').val() != '' && $('#validated_at').val() != null && $('#validated_at').val() != ''){
        $('#payment_delay_id, #validated_at').on('change', function() {
            var validatedDate = $('#validated_at').val();
            var originalDate = moment(validatedDate, "DD/MM/YYYY");
            var copyDate = originalDate.clone(); // Clone the original date for each calculation
            switch ($('#payment_delay_id').val()) {
                case "2": // 30 jours
                    copyDate.add(30, 'days');
                    break;
                case "3": // 45 jours
                    copyDate.add(45, 'days');
                    break;
                case "4": // 60 jours
                    copyDate.add(60, 'days');
                    break;
                case "5": // 30 jours fin de mois
                    copyDate.add(30, 'days').endOf('month');
                    break;
                case "6": // 45 jours fin de mois
                    copyDate.add(45, 'days').endOf('month');
                    break;
                case "7": // 45 jours fin de mois
                    copyDate.add(60, 'days').endOf('month');
                    break;
                default:
                    copyDate = originalDate.clone(); // Reset to original date if no valid option is selected
                    break;
            }

            $('#due_at').val(copyDate.format('DD/MM/YYYY'));
        });
    }
    

    $('.js-toggle-dark-mode').click(function (e) {
        e.preventDefault();
        $('body').toggleClass('dark-theme');
    });

    $('.nav-tabs').responsiveTabs();

    $(window).scroll(function () {
        if ($(window).scrollTop() >= 150) {
            $('.js-ix-page-header').addClass('fixed');
        }
        else {
            $('.js-ix-page-header').removeClass('fixed');
        }
    });

    const menuToggle = $('#ix-menu-toggle');
    const menuDropdown = $("#ix-menu-dropdown");
    const notificationsPanel = $("#ix-notifications-panel");

    $('#ix-menu-toggle').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $('#ix-menu-dropdown').toggleClass('open')
    });

    $(document).click(function (e) {
        // If the target of the click isn't the container
        if ((!menuDropdown.is(e.target) && menuDropdown.has(e.target).length === 0) || (!menuToggle.is(e.target) && menuToggle.has(e.target).length === 0)) {
            menuDropdown.removeClass('open');
        }

        if ($(".ix-menu-notification-item").has(e.target).length === 0 && notificationsPanel.hasClass('open')) {
            notificationsPanel.removeClass('open')
        }

        if ($('.ix-sidebar.open').length && !$('.ix-sidebar.open').is(e.target) && $('.ix-sidebar.open').has(e.target).length === 0 && !$('.trigger-sidebar').is(e.target) && $('.trigger-sidebar').has(e.target).length === 0 && !$('.swal-overlay').is(e.target) && $('.swal-overlay').has(e.target).length === 0 && !$('.swal2-container').is(e.target) && $('.swal2-container').has(e.target).length === 0 
             && !$('.ui-menu-item-wrapper').is(e.target) && // Remplacez '.autocomplete-element' par la classe de votre élément d'autocomplétion
            $('.ui-menu-item-wrapper').has(e.target).length === 0) {
            $('.ix-sidebar.open').removeClass('open')
        }
    });

    let scrollTo = $('body').data('scroll-to');
    if (scrollTo != undefined) {
        scrollToAnchor(scrollTo)
    }

    /**
     * Gestion des permissions a désactiver en cascade
     */
    $('.checkbox-permission').change(function () {
        var permissions = $(this).data('permissions-to-disable');
        if (permissions != "" && $(this).is(':checked')) {
            permissions = permissions.split(';');
            permissions.forEach(permission => {
                $("#" + permission).prop("checked", false);
            })
        }

    })

    /**
     * Gestion de l'unité du tarif écoparticipation
     * Met à jour l'unité affichée selon le mode de calcul sélectionné
     */
    function updateEcoRateUnit() {
        var calculationMode = $('#calculation_mode').val();
        var unitDisplay = $('#eco-rate-unit');

        if (unitDisplay.length === 0) {
            return; // L'élément n'existe pas sur cette page
        }

        if (calculationMode === 'weight') {
            unitDisplay.text('€ / kg');
        } else {
            unitDisplay.text('€ / unité');
        }
    }

    // Initialisation au chargement de la page
    updateEcoRateUnit();

    // Mise à jour quand le mode de calcul change
    $(document).on('change', '#calculation_mode', function () {
        updateEcoRateUnit();
    });

    autosize(document.querySelectorAll('textarea'));

    $(".color-picker").spectrum({
        locale: "fr",
        type: "text",
        showAlpha: false,
        showInitial: true,
        preferredFormat: "hex"
    });

    $('.delete-form').on('submit', confirmDelete);
    $('.duplicate-form').on('submit', confirmDuplicate);
    $('.accept-quotes').on('click', confirmAcceptCreateQuote);
    $('.delete-link').on('click', confirmDelete);
    $('.confirm-form').on('submit', confirmForm);
    $('.confirm-form-deal-unclosed').on('click', confirmFormDealUnClosed);
    $('.close-form').on('click', confirmCloseInspection);
    $('.delete-form-preventive').on('click', confirmDeletePreventive);

    $('.confirm-payment').on('submit', function (e) {
        e.preventDefault();
        var amount = formatCurrency($('#' + $(this).data('amount-input')).val())

        Swal.fire({
            title: amount,
            text: "Confimez-vous le montant renseigné ?",
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Corriger',
            confirmButtonText: 'Confirmer',
            reverseButtons: true,
            heightAuto: false
        }).then((result) => {
            if (result.value) {
                disableSubmitButton(this)
                this.submit()
            }
        })
    })

   /* var studyForm = document.getElementById('study-create-form');
    if (studyForm) {
      var timerId = null;
    
      var validateStudyFormRequired = function() {
        var missing = [];
        var requiredFields = studyForm.querySelectorAll('[required]');
        requiredFields.forEach(function(el) {
          var value = (el.value || '').trim();
          if (!value) {
            var label = '';
            if (el.id) {
                // lots[0][designation]
//lots[0][unit]
              var labelEl = studyForm.querySelector('label[for="'+el.id+'"]');
              if (labelEl) label = labelEl.textContent.trim();
            }
            if (!label && el.name) label = el.name;
            missing.push(label || 'Champ requis');
          }
        });
        return missing;
      };
    
      function schedulePrompt() {
        timerId = setTimeout(function() {
          Swal.fire({
            title: "Enregistrer l'étude ?",
            text: "Souhaitez-vous enregistrer l'étude maintenant ?",
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Non',
            confirmButtonText: 'Oui',
            reverseButtons: true,
            heightAuto: false
          }).then(function(result) {
            if (result && (result.value || result.isConfirmed)) {
              var missing = validateStudyFormRequired();
              if (missing.length > 0) {
                Swal.fire({
                  title: 'Champs obligatoires manquants',
                  html: "<p>Veuillez renseigner les champs obligatoires avant l'enregistrement</p>",
                  icon: 'warning',
                  confirmButtonText: 'OK',
                  heightAuto: false
                }).then(function() {
                  schedulePrompt(); // reprogrammer après le message
                });
                } else {
                    // Ajouter le paramètre de redirection pour l'enregistrement automatique
                    var formAction = studyForm.action;
                    studyForm.action = formAction + '?redirect=edit';
                    studyForm.submit();
                }
            } else {
              schedulePrompt(); // reprogrammer si l'utilisateur annule
            }
          });
        }, 10000);
      }
    
      schedulePrompt();
    
      studyForm.addEventListener('submit', function() {
        if (timerId) clearTimeout(timerId);
      });
    }*/

    $('.finish-inspection-form').on('click', function (event) {
        event.preventDefault();
        Swal.fire({
            title: "Etes-vous sûr ?",
            text: "La femeture de l'ordre de travail entrainera la mise à jour des déclencheurs de la gamme opératoire associée. Il ne sera plus possible de modifier le contenu de l'ordre de travail. ?",
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Annuler',
            confirmButtonText: 'Confirmer',
            reverseButtons: true,
            heightAuto: false
        }).then((result) => {
            if (result.value) {
                disableSubmitButton(this)
                this.submit()
            }
        })
    });

    // Saisie raison du refus d'un devis avant soumission
    $('.refuse-quote-form').on('submit', function (e) {
        e.preventDefault()
        Swal.fire({
            title: 'Indiquez la raison du refus',
            input: 'textarea',
            showCancelButton: true,
            cancelButtonText: 'Annuler',
            confirmButtonText: 'Refuser',
            reverseButtons: true,
            heightAuto: false
        }).then((result) => {
            if (result.hasOwnProperty('value')) {
                $('#refuse-reason').val(result.value)
                disableSubmitButton(this)
                this.submit()
            }
        })
    })

    // Affectation affaire ou non dans acceptation devis
    $('input[type=radio][name=create_new_deal]').change(function () {
        let value = this.value
        if (value == '1') {
            $('#deal_label').prop('readonly', true)
            $('#deal_new_name').prop('readonly', false)
            $('#deal_new_name').prop('required', true)
        } else if (value == '2') {
            $('#deal_label').prop('readonly', true)
            $('#deal_new_name').prop('readonly', true)
            $('#deal_new_name').prop('required', false)
        } else {
            $('#deal_label').prop('readonly', false)
            $('#deal_new_name').prop('readonly', true)
            $('#deal_new_name').prop('required', false)
        }
    });

    // Chagement route autocomplete lors du choix d'un objet de paiement
    $('#payment_payable_type').on('change', function (e) {
        let opt = $("option:selected", this);
        let apiUrl = opt.data('api-url');

        // reset champs autocomplete et changement url api
        $('#payment_payable_label').data('api-url', apiUrl)
        $('#payable_api_url').val(apiUrl)
        $('#payment_payable_label').val('')
        $('#payment_payable_id').val('')
    });


    /**
     * Visibilité d'un document d'article (onglet Documents) : enregistrée sans rechargement.
     * Rendre public se confirme, c'est la seule bascule qui ne se rattrape pas ; repasser en
     * privé est sans risque.
     */
    function saveDocumentVisibility(input, isPublic) {
        input.disabled = true;

        $.ajax({
            url: input.dataset.documentVisibility,
            type: 'PUT',
            dataType: 'json',
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            data: { is_public: isPublic ? 1 : 0 },
        }).done(function (data) {
            let row = $(input).closest('tr');
            input.checked = data.is_public;
            row.find('[data-document-visibility-label]').text(data.is_public ? 'Public' : 'Privé');
            // Un document privé ne s'envoie pas à un client : son lien ne se propose pas à la copie.
            row.find('[data-document-copy]').toggleClass('d-none', !data.is_public);
            row.find('[data-document-qr]').attr('data-original-title', data.is_public
                ? 'Scannez pour ouvrir directement le fichier ' + input.dataset.documentName + ' sur votre téléphone'
                : 'Document privé : le QR code demande une connexion');
            showToast(data.is_public ? 'Le document est public.' : 'Le document est privé.');
        }).fail(function () {
            input.checked = !isPublic;
            showToast("La visibilité du document n'a pas pu être enregistrée.", 'error');
        }).always(function () {
            input.disabled = false;
        });
    }

    /**
     * Copie d'un lien dans le presse-papiers, avec un retour visuel. Repli sur execCommand
     * hors contexte sécurisé (http local), où navigator.clipboard n'existe pas.
     */
    $(document).on('click', '[data-copy-link]', function (e) {
        e.preventDefault();
        let link = this.dataset.copyLink;
        let copied = () => showToast('Lien copié.');

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(link).then(copied);
            return;
        }

        let field = $('<textarea>').val(link).css({ position: 'fixed', opacity: 0 }).appendTo('body');
        field[0].select();
        document.execCommand('copy');
        field.remove();
        copied();
    });

    $(document).on('change', '[data-document-visibility]', function () {
        let input = this;

        if (!input.checked) {
            saveDocumentVisibility(input, false);
            return;
        }

        Swal.fire({
            title: 'Rendre ce document public ?',
            text: "Ce document sera visible par les tiers sur le portail et téléchargeable sans connexion par son lien ou son QR code.",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Annuler',
            confirmButtonText: 'Oui, le rendre public',
            reverseButtons: true,
            heightAuto: false
        }).then((result) => {
            if (result.value) {
                saveDocumentVisibility(input, true);
            } else {
                input.checked = false;
            }
        });
    });

    // Remove invalid class on input on blur
    $(".is-invalid").change(function () {
        $(this).removeClass('is-invalid');
    });

    $('[data-toggle="tooltip"]:not(.copy-button)').tooltip();
    $('.toast').toast('show');

    window.showToast = function(message, type) {
        type = type || 'success';
        var cssClass = type === 'error' ? 'ix-toast-error' : 'ix-toast-success';
        var $toast = $('<div class="toast" style="position: absolute; top: 10px; right: 105px;" data-delay="4000"></div>');
        if (type === 'error') {
            $toast.attr('data-autohide', 'false').removeAttr('data-delay');
        }
        $toast.html(
            '<div class="ix-toast ' + cssClass + '">' +
            message +
            '<button type="button" class="close" data-dismiss="toast" aria-label="Close">' +
            '<span aria-hidden="true"><i class="far fa-times"></i></span>' +
            '</button></div>'
        );
        $('body').append($toast);
        $toast.toast('show');
        $toast.on('hidden.bs.toast', function() { $(this).remove(); });
    };

    $('#tagsTabs a:first').tab('show');

    $('.datepicker').each(function (i, el) {
        el = $(el);

        var datepickerOptions = {
            format: "dd/mm/yyyy",
            todayBtn: true,
            language: "fr",
            calendarWeeks: true,
            autoclose: true,
            todayHighlight: true,
        }

        el.datepicker(datepickerOptions);

        el.change(function () {
            $(this)[0].dispatchEvent(new Event('input'));
        });
    })


    $('.datepicker').on('change', function () {
        var targetMin = $(this).data('set-min')
        if (targetMin) {
            $('#' + targetMin).datepicker('setStartDate', $(this).val());
        }

        var targetMax = $(this).data('set-max')
        if (targetMax) {
            $('#' + targetMax).datepicker('setEndDate', $(this).val());
        }
    });

    $('#warranty_cap_inactive').change(function () {
        if ($("#warranty_cap").length) {
            $("#warranty_cap").val("");
            if ($(this).prop('checked')) {
                $("#warranty_cap").prop("disabled", true);
            } else {
                $("#warranty_cap").prop("disabled", false);
            }
        }
    });

    $('.siren-mask').mask('000 000 000', { placeholder: "___ ___ ___" });
    $('.siret-mask').mask('000 000 000 00000', { placeholder: "___ ___ ___ _____" });
    $('.social-security-mask').mask('0 00 00 00 000 000 00', { placeholder: "_ __ __ __ ___ ___ __" });
    $('.code_validy').mask('A A A A A A A A', { placeholder: "_ _ _ _ _ _ _ _"});

    $('#ape_code').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/api/ape_codes',
                type: 'get',
                dataType: 'json',
                headers: getHeaders(),
                data: { q: request.term, maxResults: 10 },
                success: function (data) {
                    response($.map(data, function (item) {
                        return {
                            code: item.code,
                            label: item.full_label,
                            short_label: item.label,
                            value: item.code
                        }
                    }))
                }
            });
        },
        select: function (e, item) {
            if ($("#ape_label").length) {
                $("#ape_label").val(item.item.short_label)
            }
        }
    });

    $('#ape_label').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/api/ape_codes',
                type: 'get',
                dataType: 'json',
                headers: getHeaders(),
                data: { q: request.term, maxResults: 10 },
                success: function (data) {
                    response($.map(data, function (item) {
                        return {
                            code: item.code,
                            label: item.full_label,
                            short_label: item.label,
                            value: item.label
                        }
                    }))
                }
            });
        },
        select: function (e, item) {
            if ($("#ape_code").length) {
                $("#ape_code").val(item.item.code)
            }
        }
    });

    /**
     * Instanciation des différents autocomplete
     */
    if ($('.company-autocomplete').length) {
        $('.company-autocomplete').autocomplete(initAutocompleteWithParams($('.company-autocomplete'))).focus(function () {
            $(this).autocomplete("search", '');
        });
    }

    if ($('.user-autocomplete').length) {
        $('.user-autocomplete').autocomplete(initAutocompleteWithParams($('.user-autocomplete'))).focus(function () {
            $(this).autocomplete("search", '');
        });
    }

    if ($('.capacitation-autocomplete').length) {
        $('.capacitation-autocomplete').autocomplete(initAutocompleteWithParams($('.capacitation-autocomplete'))).focus(function () {
            $(this).autocomplete("search", '');
        });
    }

    /**
    * Champs autocomplete variable
    * Ce module permet d'obtenir une auto complétion sur un models demandé. Il est utilisable comme "select" déguisé ou pour permettre la création à la volé d'élément
    * data-label : Clé affiché dans les suggestions
    * data-value : Clé affiché dans l'input après selection
    * data-filters : Filtres supplémentaires à appliquer, ex: data-filters='{ "under_contract": 1}'
    */
    function initAutocompleteWithParams(instance) {
        let modelAutocompleteForceValue = instance.data("force-value");
        let modelAutocompleteUrl = instance.data("api-url");
        let modelAutocompleteLabel = instance.data("label");
        let modelAutocompleteValue = instance.data("value");
        let modelAutocompleteTargetInputId = $('#' + instance.data("target-input-id"));

        // Construction des filtres
        var modelAutocompleteFilters = instance.data("filters");
        if (modelAutocompleteFilters == undefined) {
            modelAutocompleteFilters = {};
        }

        return {
            source: function (request, response) {
                $.ajax({
                    url: modelAutocompleteUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: getHeaders(),
                    data: { ...{ q: request.term }, ...modelAutocompleteFilters },
                    success: function (data) {
                        // Liste simple, ou { data: liste } pour les ressources Laravel.
                        response($.map(Array.isArray(data) ? data : (data.data || []), function (item) {
                            return {
                                id: item.id,
                                label: item[modelAutocompleteLabel],
                                value: item[modelAutocompleteValue]
                            }
                        }))
                    }
                });
            },
            minLength: 0,
            change: function (event, item) {
                // Si la valeur n'est pas selectionnée dans les suggestions (saisie libre)
                if (!item.item) {
                    // Si l'on demande obligatoirement une valeur dans les suggestions, reset de la valeur du champs
                    if (modelAutocompleteForceValue == true) {
                        $(event.target).val("");
                    }

                    // Dans tous les cas, reset du champs associé pour éviter qu'un ID non correct soit envoyé
                    if (modelAutocompleteTargetInputId.length) {
                        modelAutocompleteTargetInputId.val("")
                    }
                }
            },
            focus: function (event, ui) {
                return false;
            },
            select: function (e, item) {
                if (modelAutocompleteTargetInputId.length) {
                    modelAutocompleteTargetInputId.val(item.item.id)
                }
            }
        }
    }


    /** 
     * Autocomplete lors de la création d'une société
     * Permet de consulter les sociétés déjà existantes
     */
    $('#autocomplete_company_name').autocomplete({
        minLength: 0,
        source: function (request, response) {
            $.ajax({
                url: $('#autocomplete_company_name').data("api-url"),
                type: 'get',
                dataType: 'json',
                headers: getHeaders(),
                data: { ...{ q: request.term } },
                success: function (data) {
                    response($.map(data, function (item) {
                        return Object.assign(item, {
                            label: item['name'] ?? '',
                            value: item['name'] ?? '',
                        })
                    }))
                }
            });
        },
    })

    /**
     * Champs autocomplete variable
     * Ce module permet d'obtenir une auto complétion sur un models demandé. Il est utilisable comme "select" déguisé ou pour permettre la création à la volé d'élément
     * data-label : Clé affiché dans les suggestions
     * data-value : Clé affiché dans l'input après selection
     * data-filters : Filtres supplémentaires à appliquer, ex: data-filters='{ "under_contract": 1}'
     */
    $('input.model-autocomplete').each(function (i, el) {
        el = $(el);
        el.autocomplete({
            minLength: 0,
            source: function (request, response) {
                $.ajax({
                    url: el.data("api-url"),
                    type: 'get',
                    dataType: 'json',
                    headers: getHeaders(),
                    data: { ...{ q: request.term }, ...el.data("filters") === undefined ? {} : el.data("filters") },
                    success: function (data) {
                        const items = Array.isArray(data) ? data : (data && Array.isArray(data.data) ? data.data : data);
                        response($.map(items, function (item) {
                            return Object.assign(item, {
                                label: item[el.data("label")] ?? '',
                                value: item[el.data("value")] ?? '',
                            })
                        }))
                    }
                });
            },
            change: function (event, item) {
                const fn = el.data("extra-fn");
                // Si la valeur n'est pas selectionnée dans les suggestions (saisie libre)
                if (!item.item) {
                    // Si l'on demande obligatoirement une valeur dans les suggestions, reset de la valeur du champs
                    if (el.data("force-value") == true) {
                        $(event.target).val("");
                    }

                    // Dans tous les cas, reset du champs associé pour éviter qu'un ID non correct soit envoyé
                    if ($('#' + el.data("target-input-id")).length) {
                        $('#' + el.data("target-input-id")).val("").change();
                    }
                }

                // Traitement supplémentaire
                if (fn == 'fillLotFromMovement') {
                    if (item.item != null) {
                        if (item.item.lots.length >= 1) {
                            $('#lot_label').removeAttr('disabled');
                        } else {
                            $('#lot_label').attr('disabled', true);
                        }
                    }
                }

                if(fn == 'fillDealContactMission'){
                    if(item.item && item.item.contact){
                        if(item.item.contact.gender !== null && item.item.contact.gender !== undefined) {
                            $('input[name="gender"][value="' + item.item.contact.gender + '"]').prop('checked', true);
                        }

                        $('#firstname').val(item.item.contact.firstname);
                        $('#lastname').val(item.item.contact.lastname);
                        $('#job').val(item.item.contact.job);
                        $('#email').val(item.item.contact.email);
                        $('#phone').val(item.item.contact.phone);
                        $('#mobile').val(item.item.contact.mobile);
                        $('#description').val(item.item.contact.description);
                    }
                    
                }

                if (fn == 'fillDealFromPreventive') {
                    if (!$('#equipment_name').val()) {
                        $('#deal_name').attr('disabled', false);
                    }
                }
            },
            focus: function (event, ui) {
                return false;
            },
            select: function (e, item) {
                if ($('#' + el.data("target-input-id")).length) {
                   $('#' + el.data("target-input-id")).val(item.item.id).change();
                }

                // Traitement supplémentaire
                const fn = el.data("extra-fn");

                if (fn == 'fillExpectedAtFromOrder') {
                    if (!$('#expected_at').val()) {
                        $('#expected_at').val(item.item.expected_at)
                    }
                }

                
                if (fn == 'fillDealFromMovement' || fn == 'fillDealFromPreventive') {
                    $('#deal_name').val(item.item.deal.designation);
                    $('#deal_id').val(item.item.deal.id);
                }

                if(fn == 'fillLotFromMovement'){
                    if($('#lot_label').length > 0){
                        $('#lot_label').data('filters', {'deal_id' : item.item.id, 'states' : "2,3"});
                    }
                }
                
              
                setTimeout(function () {
                    $(e.target).blur();
                })
            }
        }).focus(function () {
            el.autocomplete("search", '');
        });

        if (el.hasClass('article-autocomplete')) {
            el.autocomplete("instance")._renderItem = formatArticlesAutocomplete
        }

        if (el.hasClass('company-autocomplete')) {
            el.autocomplete("instance")._renderItem = formatCompaniesAutocomplete
        }
    });

    /**
     * Formattage de l'autocomplete des articles
     */
    function formatArticlesAutocomplete(ul, item) {
        let numberString = item.number ? "<br>Ref. interne: " + item.number : "";
        let referenceString = item.reference ? "<br>Ref. fournisseur: " + item.reference : "";
        return $("<li>")
            .append("<div>" + item.label + `<span style='font-size: 10px'>${numberString}${referenceString}</span></div>`)
            .appendTo(ul);
    }

    /**
     * Formattage de l'autocomplete des sociétés
     */
    function formatCompaniesAutocomplete(ul, item) {
        let labelSubcontractor = item.label_subcontractor ? "<br>" + item.label_subcontractor : "";
        let typeArea = item.type_area ? "<br>" + item.type_area : "";
        return $("<li>")
            .append("<div>" + item.label + `<span style='font-size: 10px'>${labelSubcontractor}${typeArea}</span></div>`)
            .appendTo(ul);
    }

    /**
     * Depuis un champs autocomplete (société, ..)
     * Mise en place des filtres sur des champs en autocomplete eux aussi (contact, adresse, ..)
     */
    $('.input-change-filters-autocomplete').change(function () {
        let f = $(this).attr('id')
        let targets = $(this).data('targets').split(',')
        let newValue = $(this).val()
        let clear = newValue == ''

        targets.forEach((target, index) => {
            if ($(`#${target}_id`).length && $(`#${target}_label`)) {
                // Verrouillage du champs
                if (clear) {
                    $(`#${target}_label`).prop('readonly', true)
                } else {
                    $(`#${target}_label`).prop('readonly', false)
                }

                if ($('#equipment_label')) {
                    $('#equipment_label').prop('readonly', false);
                }

                $(`#${target}_id`).val('')
                $(`#${target}_label`).val('')

                // Construction des filtres
                var filters = $(`#${target}_label`).data('filters')
                if (typeof filters != "object") {
                    filters = {}
                }

                // Affectation de la nouvelle valeur aux filtres du champs autocomplete target
                filters[f] = newValue
                $(`#${target}_label`).data('filters', filters)
            }
        })
    });
    /**
     * Récupération des informations d'une société pour précomplétion d'une page
     * Eg. Devis, Commande fournisseur avec adresse par défaut, etc ..
     */
    $('.input-trade-company-setup').change(function () {
        let newValue = $(this).val()
        if (newValue != '' && newValue != undefined) {
            var defaultsUrl = $(this).data('defaults-url').replace('##', newValue)
            $('#company_note').text('');
            $('#circle-load').css({ 'display': 'block' });
            fetch(defaultsUrl, {
                headers: getHeaders(),
                method: 'GET'
            }).then(function (response) {
                if (response.status == 200) {
                    response.json().then(function (data) {
                        if (data.data) {
                            let el = document.getElementById("discount");
                            if (data.data.billing_address) {
                                $('#address_id').val(data.data.billing_address.id)
                                $('#address_label').val(data.data.billing_address.line_formatted)
                            }

                            if (data.data.note) {
                                $('#circle-load').css({ 'display': 'none' });
                                $('#company_note').text(data.data.note);
                            } else {
                                $('#circle-load').css({ 'display': 'none' });
                                $('#company_note').text('Aucune note associée à cette entreprise');
                            }

                            // Niveau de remise du client, le champ n'existe que grille ouverte
                            if ($('#company_discount_profile').length) {
                                $('#company_discount_profile').text(data.data.discount_profile ? data.data.discount_profile : 'Aucun');
                            }

                            if (data.data.payment_method_id) {
                                $('#payment_method_id').val(data.data.payment_method_id)
                            }

                            if (data.data.payment_delay_id) {
                                $('#payment_delay_id').val(data.data.payment_delay_id)
                            }

                            if(data.data.is_subcontractor != null && $('#is_subcontractor').length > 0){
                                $('#is_subcontractor').val(data.data.is_subcontractor)
                            }

                            if(data.data.type_area != null && $('#type_area').length > 0){
                                $('#type_area').val(data.data.type_area)
                            }

                            if(data.data.default_vat != null && $('#default_vat').length > 0){
                                $('#default_vat').val(data.data.default_vat)
                            }

                            if (data.data.discount && el != null) {
                                el.value = data.data.discount;
                                el.dispatchEvent(new Event('input'));

                                Swal.fire({
                                    title: 'Remise automatique',
                                    text: "Une remise de " + data.data.discount + "% a été appliquée depuis la fiche client.",
                                    icon: 'info',
                                    showCancelButton: false,
                                    confirmButtonText: 'Continuer',
                                    reverseButtons: true,
                                    heightAuto: false
                                })
                            }
                        }
                    })
                }
            }).catch(function (error) {
                alertError(null)
            });
        }
    })

    /**
     * Récupération des informations d'une commande pour précomplétion
     * Eg. BL
     */
    $('.input-trade-order-setup').change(function () {
        let newValue = $(this).val()
        if (newValue != '' && newValue != undefined) {
            var defaultsUrl = $(this).data('defaults-url').replace('##', newValue)

            fetch(defaultsUrl, {
                headers: getHeaders(),
                method: 'GET'
            }).then(function (response) {
                if (response.status == 200) {
                    response.json().then(function (data) {
                        if (data.data) {
                            var deliveryAddress = data.data.delivery_address ? data.data.delivery_address : data.data.billing_address;

                            if (deliveryAddress) {
                                $('#delivery_address_id').val(deliveryAddress.id)
                                $('#delivery_address_label').val(deliveryAddress.line_formatted)
                            }

                            if (data.data.company) {
                                $('#company_id').val(data.data.company.id)
                                $('#company_name').val(data.data.company.name)
                            }

                            $('#delivery_address_label').prop('readonly', false)
                        }
                    })
                }
            }).catch(function (error) {
                alertError(null)
            });
        } else {
            $('#company_id').val('')
            $('#company_name').val('')

            $('#delivery_address_id').val('')
            $('#delivery_address_label').val('')
            $('#delivery_address_label').prop('readonly', true)
        }
    })
    
    /**
     * Autocomplete depuis ligne
     * data-target-input-reference : Champs cible pour stockage de la référence
     * data-target-input-designation : Champs cible pour stockage de la designation
     * data-target-input-unit: Champs cible pour stockage de l'unité
     * data-target-input-amount : Champs cible pour stockage du montant
     * data-target-input-description : Champs cible pour stockage de la description
     */
    $('input.line-autocomplete').each(function (i, el) {
        el = $(el);
        el.autocomplete({
            minLength: 0,
            source: function (request, response) {
                $.ajax({
                    url: el.data("api-url"),
                    type: 'get',
                    dataType: 'json',
                    headers: getHeaders(),
                    data: { ...{ q: request.term }, ...el.data("filters") === undefined ? {} : el.data("filters") },
                    success: function (data) {
                        response($.map(data, function (item) {
                            return Object.assign(item, {
                                label: item.autocomplete_label,
                                value: item[el.data("value")] ?? ''
                            })
                        }))
                    }
                });
            },
            change: function (event, item) {
                // Si la valeur n'est pas selectionnée dans les suggestions (saisie libre)
                if (!item.item) {
                    $('#' + el.data("target-input-quantity-label")).html('-')
                    $('#' + el.data("target-input-line")).val('')
                }
            },
            focus: function (event, ui) {
                return false;
            },
            select: function (e, item) {
                if (item.item) {
                    $('#' + el.data("target-input-reference")).val(item.item.reference)
                    $('#' + el.data("target-input-designation")).val(item.item.designation)
                    $('#' + el.data("target-input-quantity")).val(item.item.remaining_quantity)
                    $('#' + el.data("target-input-unit")).val(item.item.unit)
                    $('#' + el.data("target-input-description")).val(item.item.description)
                    $('#' + el.data("target-input-line")).val(item.item.id)

                    $('#' + el.data('target-select-line-type')).val(item.item.is_title).change()
                    $('#' + el.data("target-input-quantity-label")).html(item.item.remaining_quantity)
                }

                setTimeout(function () {
                    $(e.target).blur();
                })
            }
        }).focus(function () {
            el.autocomplete("search", '');
        });
    });

    $('.check-all').click(function () {
        $('.' + $(this).data('check-all-container-target') + ' input[type="checkbox"]').prop('checked', this.checked)

        var container = $('.' + $(this).data('check-all-container-target')).closest('.check-all-container');
        displayActionsWhenSelectionNeeded(container)
        updateTextTotalRemaining();
        updateProgressPreview();
        updateNormalPreview();
    })

    $('.check-one').change(function () {
        var checkAll = $('#' + $(this).data('check-all-target'));
        var checkAllContainer = $(this).closest('.check-all-container');
        var checkboxes = $("input[type=\"checkbox\"]:not(:checked)")
        let uncheckedCount = checkAllContainer.find(checkboxes).length

        displayActionsWhenSelectionNeeded(checkAllContainer)
        updateTextTotalRemaining();
        updateProgressPreview();
        updateNormalPreview();

        if (uncheckedCount == 0) {
            checkAll.prop('checked', true)
        } else {
            checkAll.prop('checked', false)
        }
    })

    function displayActionsWhenSelectionNeeded(container) {
        var checkedCheckboxes = $("input[type=\"checkbox\"]:checked")
        let checkedCount = container.find(checkedCheckboxes).length

        if (checkedCount > 0) {
            $('.need-selection').css('display', 'block')
        } else {
            $('.need-selection').attr('style', 'display: none !important');
        }
    }

    $('#allow_login_switch').change(function () {
        const el = $(this)
        const allow = $(this).is(':checked')

        fetch($(this).data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ is_allow: allow })
        }).then(function (response) {
            if (response.status != 200) {
                if (allow) {
                    el.prop('checked', false)
                } else {
                    el.prop('checked', true)
                }
            }
        }).catch(function (error) {
            if (allow) {
                el.prop('checked', false)
            } else {
                el.prop('checked', true)
            }
        });
    })

    // Édition d'un pointage utilisateur : afficher / masquer la liste des pointages
    // matériels associés et permettre une sélection fine de ceux à mettre à jour.
    if ($('#equipment-checkings-list').length) {
        const $list  = $('#equipment-checkings-list');
        const $cbs   = $('.equipment-checking-checkbox');

        function toggleEquipmentCheckingsList() {
            if ($('#edit_equipment_checking_true').is(':checked')) {
                $list.show();
            } else {
                $list.hide();
            }
        }

        $('input[name="edit_equipment_checking"]').on('change', toggleEquipmentCheckingsList);

        $('#equipment-checkings-select-all').on('click', function () {
            $cbs.prop('checked', true);
        });

        $('#equipment-checkings-unselect-all').on('click', function () {
            $cbs.prop('checked', false);
        });
    }

    $('#fast_checking_switch').change(function () {
        const el = $(this)
        const allow = $(this).is(':checked')

        fetch($(this).data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ fast_checking: allow })
        }).then(function (response) {
            if (response.status != 200) {
                if (allow) {
                    el.prop('checked', false)
                } else {
                    el.prop('checked', true)
                }
            }
        }).catch(function (error) {
            if (allow) {
                el.prop('checked', false)
            } else {
                el.prop('checked', true)
            }
        });
    })

 

    $('#lost_switch').change(function () {
        const el = $(this)
        const allow = $(this).is(':checked')

        fetch($(this).data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ is_lost: allow })
        }).then(function (response) {
            if (response.status != 200) {
                if (allow) {
                    el.prop('checked', false)
                } else {
                    el.prop('checked', true)
                }
            }
        }).catch(function (error) {
            if (allow) {
                el.prop('checked', false)
            } else {
                el.prop('checked', true)
            }
        });
    })

    $('#sleeping_switch').change(function () {
        const el = $(this)
        const allow = $(this).is(':checked')

        fetch($(this).data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ is_sleeping: allow })
        }).then(function (response) {
            if (response.status != 200) {
                el.prop('checked', !allow)
            }
        }).catch(function () {
            el.prop('checked', !allow)
        });
    })


    $('#switch_status').change(function () {
        const el = $(this)
        const check = el.is(':checked')

        fetch(el.data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ is_check: check })
        }).then(function (response) {
            if (response.status != 200) {
                if (check) {
                    el.prop('checked', false)
                } else {
                    el.prop('checked', true)
                }
            }
        }).catch(function (error) {
            if (check) {
                el.prop('checked', false)
            } else {
                el.prop('checked', true)
            }
        });
    })

     /**
     * Modal décision facture fournisseur (refus / litige)
     * Injecte le state et réinitialise le formulaire
     */
    $('#billDecisionModal').on('show.bs.modal', function (e) {
        var btn   = $(e.relatedTarget);
        var state = btn.data('state');
        $(this).find('#billDecisionState').val(state);
        $(this).find('#billDecisionReason').val('');
    });

    /**
     * Paiement multiple depuis sélection
     */
    $('.pay-all').click(function () {
        const checkboxes = $('.check-payable').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];

        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })

            $('#paymentPayableId').val(ids.join())
            $('#createPaymentModal').modal()
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }
    });
    /** 
     * Affichage/Masquage du champ de saisie du moyen de paiement si l'avoir est déduit  
    */
    function togglePaymentMethod() {
        if ($('#deductible_yes').is(':checked')) {
            $('#payment_method_div').hide();
        } else {
            $('#payment_method_div').show();
        }
    }

    // Appel initial pour définir l'état correct au chargement
    togglePaymentMethod();

    // On détecte le changement de valeur de l'input radio
    $('input[type=radio][name="payment[is_deductible]"]').change(function() {
        togglePaymentMethod();
    });



    /**
     * Création ordre de paiement depuis liste des factures fournisseurs
     */
    $('.payment-orders-all').click(function () {
        const checkboxes = $('.check-payable').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];

        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })

            $('#paymentOrderBillIds').val(ids.join())
            $('#createPaymentOrderModal').modal()
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }
    });
    

    $('.all-visa-expenses').click(function () {
        const checkboxes = $('.check-expenses').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];
        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })

            $('#expenseVisaIds').val(ids.join())
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }

    }) 


    $('.valid-all-checkings').click(function () {
        const checkboxes = $('.check-checkings').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];
        if (checkboxes.length > 0) {
            // met moi un swal pour confirmer l'action, si oui on valid le formulaire
            Swal.fire({
                title: 'Confirmation',
                text: "Êtes-vous sûr de vouloir valider ces pointages ?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
                reverseButtons: true,
                heightAuto: false
            }).then((result) => {
                if (result.isConfirmed) {
                    checkboxes.each(function () {
                        ids.push($(this).val())
                    })
                    $('#checkingValidIds').val(ids.join())
                    $('#validCheckingsForm').submit()
                }
            })
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }

    }) 

    /**
     * Confirmation modal before enabling public (third-party) access on contact switch
     */
    $(document).on('change', '.auth_allowed_public_switch', function (e) {
        const el = $(this);
        const allow = el.is(':checked');
        const apiUrl = el.data('api-url');
        const contactName = el.data('contact-name') || '';
        const contactEmail = el.data('contact-email') || '';

        function showInlineAlert(type, text) {
            const alertClass = type === 'success' ? 'alert-success' : 'alert-danger';
            const icon = type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle';
            const $alert = $(
                '<div class="alert '+alertClass+' alert-dismissible fade show position-fixed" style="top:20px;right:20px;z-index:9999;min-width:320px;">'
                + '<i class="fas '+icon+' mr-2"></i>' + text
                + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
                + '</div>'
            );
            $('body').append($alert);
            setTimeout(() => { $alert.alert('close'); }, 5000);
        }

        function sendUpdate(allowed) {
            return fetch(apiUrl, {
                headers: getHeaders(),
                method: 'PUT',
                body: JSON.stringify({ auth_allowed: allowed })
            }).then(function (response) {
                if (response.status == 200) {
                    // Hide modal if present
                    if (allowed) {
                        const $m = $('#confirmPublicAccessModal');
                        if ($m.length) { $m.modal('hide'); }
                    }
                    setTimeout(function () { location.reload(); }, allowed ? 200 : 0);
                } else {
                    el.prop('checked', !allowed);
                    showInlineAlert('error', "Une erreur est survenue lors de la mise à jour de l'accès.");
                }
            }).catch(function () {
                el.prop('checked', !allow);
                // Hide modal on error if present
                const $m = $('#confirmPublicAccessModal');
                if ($m.length) { $m.modal('hide'); }
                showInlineAlert('error', "Impossible de contacter le serveur. Veuillez réessayer.");
            });
        }

        // If disabling, update immediately without modal
        if (!allow) {
            return sendUpdate(false);
        }

        // If enabling, show confirmation modal
        const $modal = $('#confirmPublicAccessModal');
        if ($modal.length === 0) {
            // Fallback: no modal available, revert and do nothing
            el.prop('checked', false);
            return;
        }

        $('#modalContactName').text(contactName);
        $('#modalContactEmail').text(contactEmail);

        const onConfirm = function () {
            $modal.off('hidden.bs.modal', onHide);
            $('#confirmPublicAccessBtn').off('click', onConfirm);
            // UI loading state
            const $btn = $('#confirmPublicAccessBtn');
            const originalHtml = $btn.html();
            $btn.data('original-html', originalHtml);
            $btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>Activation...');
            el.prop('disabled', true);

            sendUpdate(true).finally(function(){
                // Restore UI if not reloaded yet (in case of error)
                $btn.prop('disabled', false).html($btn.data('original-html'));
                el.prop('disabled', false);
            });
        };

        const onHide = function () {
            // If user closed modal without confirming, revert the switch
            el.prop('checked', false);
            $modal.off('hidden.bs.modal', onHide);
            $('#confirmPublicAccessBtn').off('click', onConfirm);
        };

        $('#confirmPublicAccessBtn').on('click', onConfirm);
        $modal.on('hidden.bs.modal', onHide);
        $modal.modal('show');
    });

    $('.all-fast-invoices-payments').click(function () {
        const checkboxes = $('.check-fast-invoices').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];

        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })
            $('#invoiceIds').val(ids.join());
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }

        
    })

    $('.all-maintenance-operations').click(function () {
        const checkboxes = $('.check-maintenance-operations').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];

        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })

            $('#maintenanceOperationsIds').val(ids.join())
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }

    })

    /*
    * Ajout d'un compte depuis la modal du plan comptable
    */
    $('.button-add-accounting').on('click', function (e) {
        e.preventDefault();
        let accountingType = $(this).data('accounting-type');
        let companyName = $('#name').length ? $('#name').val() : '';

        if (accountingType == 'eco') {

            $('#modal_accounting_name').val('Produits issus d\'activités annexes');
            $('#modal_accounting_general').val('708');
            $('#modal_accounting_type').val('eco');
        } else {
            let isCompany = accountingType == 'company';
            $('#modal_accounting_name').val(isCompany ? 'Compte client ' + companyName : 'Compte fournisseur ' + companyName);
            $('#modal_accounting_general').val(isCompany ? '411' : '401');
            $('#modal_accounting_type').val(isCompany ? 'company' : 'provider');
        }

        $('#createAccountingAccountModal').modal();
    });
    
    $('#modal-submit-accounting').on('click', function (e) {
        e.preventDefault();

        let accountingGeneral = $('#modal_accounting_general').val();
        let accountingAuxiliary = $('#modal_accounting_auxiliary').val();
        let accountingName = $('#modal_accounting_name').val();

        if (accountingGeneral == '' || accountingName == '') {
            alertError("Veuillez renseigner l'ensemble des champs obligatoires");
        } else {
            let submitUrl = $(this).data('submit-url');
            var data = {
                general: accountingGeneral,
                auxiliary: accountingAuxiliary,
                name: accountingName
            };


            disableButtonAndLoad($(this));

            fetch(submitUrl, {
                headers: getHeaders(),
                method: 'POST',
                body: JSON.stringify(data)
            }).then(res => {
                if (res.status == 200 || res.status == 201) {
                    res.json().then((data) => {
                        if (data.data) {
                            let accountingType = $('#modal_accounting_type').val();
                            if (accountingType == 'company') {
                                $('#client_accounting_account_designation').val(data.data.designation);
                                $('#client_accounting_account_id').val(data.data.id);
                            } else if (accountingType == 'provider') {
                                $('#provider_accounting_account_designation').val(data.data.designation);
                                $('#provider_accounting_account_id').val(data.data.id);
                            } else if (accountingType == 'eco') {
                                $('#accounting_account_designation').val(data.data.designation);
                                $('#accounting_account_id').val(data.data.id);
                            }

                            $('#modal_accounting_general').val('');
                            $('#modal_accounting_auxiliary').val('');
                            $('#modal_accounting_name').val('');


                            $('#createAccountingAccountModal').modal('hide');
                        } else {
                            alertError(null);
                        }
                        resetButtonAfterLoad($(this));
                    })
                } else {
                    console.log(res.status);
                    alertError(res.status == 422 ? 'Le compte renseigné existe déjà' : null);
                    resetButtonAfterLoad($(this));
                }

            }).catch((error) => {
                alertError(null)
                resetButtonAfterLoad($(this));
            });
        }
    });


    /** Edition d'un compte depuis la modale plan comptable */
    $('.button-edit-accounting').on('click', function (e) {
        let accountType = $(this).data('accounting-type');
        let accountId = $(this).data('account-id');
        let accountGeneral = $(this).data('account-general');
        let accountAuxiliary = $(this).data('account-auxiliary');
        let accountName = $(this).data('account-name');
        let dataUrl = $(this).data('url');
        
        // Update the modal fields
        $('#modal_edit_accounting_general').val(accountGeneral);
        $('#modal_edit_accounting_auxiliary').val(accountAuxiliary);
        $('#modal_edit_accounting_name').val(accountName);
        $('#modal_edit_accounting_id').val(accountId);
        $('#modal_edit_accounting_type').val(accountType);
        // Update 
        $('#modal-submit-edit-accounting').attr('data-submit-url', dataUrl);

        $('#editAccountingAccountModal').modal();

    });

    $('#modal-submit-edit-accounting').on('click', function (e) {

        e.preventDefault();

        let accountingGeneral = $('#modal_edit_accounting_general').val();
        let accountingAuxiliary = $('#modal_edit_accounting_auxiliary').val();
        let accountingName = $('#modal_edit_accounting_name').val();
        let accountingId = $('#modal_edit_accounting_id').val();
        let accountType= $('#modal_edit_accounting_type').val();

        if (accountingGeneral == '' || accountingName == '') {
            alertError("Veuillez renseigner l'ensemble des champs obligatoires");
        } else {
            let submitUrl = $(this).data('submit-url');
            var data = {
                type : accountType,
                general: accountingGeneral,
                auxiliary: accountingAuxiliary,
                name: accountingName,
                id : accountingId,
            };

            disableButtonAndLoad($(this));

            fetch(submitUrl, {
                headers: getHeaders(),
                method: 'PUT',
                body: JSON.stringify(data)
            }).then(res => {
                if (res.status == 200 || res.status == 201) {
                    res.json().then((data) => {
                        resetButtonAfterLoad($(this));
                        // Close the modal
                        $('#editAccountingAccountModal').modal('hide');
                        // On recharge la page
                        location.reload();
                        
                    })
                } else {
                    console.log(res.status);
                    alertError(res.status == 422 ? 'Le compte renseigné existe déjà' : null);
                    resetButtonAfterLoad($(this));
                }

            }).catch((error) => {
                alertError(null)
                resetButtonAfterLoad($(this));
            });
        }
    });

    /**
     * Ajout d'une société depuis modal 
     */
    $('.button-add-company').on('click', function(e){
        $('#addCompanyModal').modal();
        

        $('#modal_is_enterprise').change(function() {
            let value = this.value;
            // Gestion cas particulier 
            if(value == 0){
                $('#modal_contact_section').css({'display' : 'block'});
            } else {
                $('#modal_contact_section').css({'display' : 'none'});
            }


            e.preventDefault();
        });

        $('#button-submit-company').off('click').click(function () {
            let companyModalName = $('#autocomplete_company_name').val();
            let companyModalPhone = $('#modal_phone').val();
            let companyModalMail =  $('#modal_email').val();
            let companyModalFirstName = $('#modal_firstname').val();
            let companyModalIsEnterprise = $('#modal_is_enterprise').val();

            if(companyModalName == '')
                alertError("Veuillez renseigner l'ensemble des champs obligatoires");
            else {
                let submitUrl = $(this).data('submit-url')
                
                var data = {
                    name: companyModalName,
                    email: companyModalMail,
                    phone: companyModalPhone,
                    firstname: companyModalFirstName,
                    warranty_cap_inactive: true,
                    state: 2,
                    is_enterprise: companyModalIsEnterprise,
                    gender: 1,
                };

                disableButtonAndLoad($(this));

                 // Envoi serveur
                fetch(submitUrl, {
                    headers: getHeaders(),
                    method: 'POST',
                    body: JSON.stringify(data)
                }).then(res => {
                    res.json().then((data) => {
                        if (data.data) {
                            $('#company_id').val(data.data?.id);
                            $('#company_name').val(data.data?.name).trigger('change');
                            console.log($('#company_id').val());

                            // Réinitialisation du formulaire de la modal
                            $('#autocomplete_company_name').val('');
                            $('#modal_phone').val('');
                            $('#modal_email').val('');
                            $('#modal_firstname').val();
                            $('#modal_is_enterprise').val(1);

                            $('#addCompanyModal').modal('hide')
                        } else {
                            let errorMessage = null;
                            if (data && data.errors) {
                                errorMessage = Object.values(data.errors).map(err => Array.isArray(err) ? err.join(', ') : err).join('\n');
                            } else if (data && data.message) {
                                errorMessage = data.message;
                            }
                            alertError(errorMessage);
                        }

                        resetButtonAfterLoad($(this));
                    })
                }).catch((error) => {
                    alertError(null)
                    resetButtonAfterLoad($(this));
                });
                }
            })
    });

    /**
     * Ajout adresse depuis modal (devis, commandes, factures, etc .. par exemple)
     */
    $('.button-add-address').click(function () {
        let companyName = $('#company_name').val()
        let companyId = $('#company_id').val()
        let isBilling = $(this).data('address-type') == 'billing'

        // Vérification de la présence d'un nom de société
        if (companyName == '' || companyName == undefined || companyName == null) {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez d'abord renseigner le nom de la société avant de pouvoir saisir une nouvelle adresse",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                reverseButtons: true
            })
        } else {
            $('#modal_address_type').val($(this).data('address-type'))
            $('#modal_address_company_name').val(companyName)
            $('#modal_address_company_id').val(companyId)

            if (isBilling) {
                $("#modal_address_is_default_true").prop("checked", true);;
            } else {
                $("#modal_address_is_default_false").prop("checked", true);;
            }

            $('#addAddressModal').modal()
        }
    });

    $('#button-submit-address').click(function () {
        let companyName = $('#modal_address_company_name').val()
        let companyId = $('#modal_address_company_id').val()
        let name = $('#modal_address_name').val()
        let address1 = $('#modal_address_address_1').val()
        let address2 = $('#modal_address_address_2').val()
        let zipCode = $('#modal_address_zip_code').val()
        let city = $('#modal_address_city').val()
        let country = $('#modal_address_country').val()
        let description = $('#modal_address_description').val()
        let is_default = $("input[name=modal_address_is_default]:checked").val()

        // Contrôle du formulaire
        if (companyName == '' || name == '' || address1 == '' || zipCode == '' || city == '' || country == '') {
            alertError("Veuillez renseigner l'ensemble des champs obligatoires")
        } else {
            let submitUrl = $(this).data('submit-url')
            var data = {
                is_default: is_default,
                company_name: companyName,
                name: name,
                address_1: address1,
                address_2: address2,
                zip_code: zipCode,
                city: city,
                country: country,
                description: description,
            };

            if (companyId != '' && companyId != undefined && companyId != null) {
                data.company_id = companyId
            }

            disableButtonAndLoad($(this));

            // Envoi serveur
            fetch(submitUrl, {
                headers: getHeaders(),
                method: 'POST',
                body: JSON.stringify(data)
            }).then(res => {
                res.json().then((data) => {
                    if (data.data) {
                        // affectation au formulaire principal
                        $('#company_name').val(companyName)

                        let currentCompanyId = $('#company_id').val();
                        if (currentCompanyId != data.data.company_id) {
                            $('#company_id').val(data.data.company_id).trigger('change')
                        }

                        let addressType = $('#modal_address_type').val()
                        if (addressType == 'delivery') {
                            $('#delivery_address_label').val(data.data.line_formatted)
                            $('#delivery_address_id').val(data.data.id)
                        } else {
                            $('#address_label').val(data.data.line_formatted).trigger('input')
                            $('#address_id').val(data.data.id).trigger('input').trigger('change')
                        }

                        // Réinitialisation du formulaire de la modal
                        $('#modal_address_company_name').val('')
                        $('#modal_address_company_id').val('')
                        $('#modal_address_name').val('')
                        $('#modal_address_address_1').val('')
                        $('#modal_address_address_2').val('')
                        $('#modal_address_zip_code').val('')
                        $('#modal_address_city').val('')
                        $('#modal_address_country').val('')
                        $('#modal_address_description').val('')
                        $('#modal_address_type').val('')

                        // Fermeture modal
                        $('#addAddressModal').modal('hide')
                    } else {
                        alertError(null)
                    }

                    resetButtonAfterLoad($(this));
                })
            }).catch((error) => {
                alertError(null)
                resetButtonAfterLoad($(this));
            });
        }
    });

    $('#button-add-contact').click(function () {
        let companyName = $('#company_name').val()
        let companyId = $('#company_id').val()

        // Vérification de la présence d'un nom de société
        if (companyName == '' || companyName == undefined || companyName == null) {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez d'abord renseigner le nom de la société avant de pouvoir saisir un nouveau contact",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                reverseButtons: true
            })
        } else {
            $('#modal_contact_company_name').val(companyName)
            $('#modal_contact_company_id').val(companyId)
            $('#addContactModal').modal()
        }
    });

    $('#button-submit-contact').click(function () {
        let companyName = $('#modal_contact_company_name').val()
        let companyId = $('#modal_contact_company_id').val()
        let gender = $('input[name=modal_contact_gender]:checked').val()
        let lastname = $('#modal_contact_lastname').val()
        let firstname = $('#modal_contact_firstname').val()
        let job = $('#modal_contact_job').val()
        let email = $('#modal_contact_email').val()
        let phone = $('#modal_contact_phone').val()
        let mobile = $('#modal_contact_mobile').val()
        let description = $('#modal_contact_description').val()

        // Contrôle du formulaire
        if (lastname == '') {
            alertError("Veuillez renseigner l'ensemble des champs obligatoires")
        } else {
            let submitUrl = $(this).data('submit-url')
            var data = {
                company_name: companyName,
                gender: gender,
                lastname: lastname,
                firstname: firstname,
                job: job,
                email: email,
                phone: phone,
                mobile: mobile,
                description: description,
            };

            if (companyId != '' && companyId != undefined && companyId != null) {
                data.company_id = companyId
            }

            disableButtonAndLoad($(this));

            // Envoi serveur
            fetch(submitUrl, {
                headers: getHeaders(),
                method: 'POST',
                body: JSON.stringify(data)
            }).then(res => {
                res.json().then((data) => {
                    if (data.data) {
                        // affectation au formulaire principal
                        $('#company_name').val(companyName)

                        let currentCompanyId = $('#company_id').val();
                        if (currentCompanyId != data.data.company_id) {
                            $('#company_id').val(data.data.company_id).trigger('change')
                        }

                        $('#contact_label').val(data.data.fullname)
                        $('#contact_id').val(data.data.id)

                        // Réinitialisation du formulaire de la modal
                        $('#modal_contact_company_name').val('')
                        $('#modal_contact_company_id').val('')
                        $("#modal_contact_gender1").prop("checked", true);
                        $('#modal_contact_lastname').val('')
                        $('#modal_contact_firstname').val('')
                        $('#modal_contact_job').val('')
                        $('#modal_contact_email').val('')
                        $('#modal_contact_phone').val('')
                        $('#modal_contact_mobile').val('')
                        $('#modal_contact_description').val('')

                        // Fermeture modal
                        $('#addContactModal').modal('hide')
                    } else {
                        alertError(null)
                    }

                    resetButtonAfterLoad($(this));
                })
            }).catch((error) => {
                alertError(null)
                resetButtonAfterLoad($(this));
            });
        }
    });

    /**
     * Depuis un bouton dans une ligne d'un tableau, permet la suppression de la ligne en question
     */
    $(document).on('click', '.delete-current-row', function (e) {
        e.preventDefault();
        $(this).closest("tr").remove();
    });

    /**
     * Module Tags
     * Transforme un input/textarea en selecteur de tags
     *
     * https://github.com/yairEO/tagify
     */
    document.querySelectorAll('.tag-autocomplete').forEach(createInputTag);
    window.createInputTag = createInputTag;

    function createInputTag(field) {
        var timeout;
        var controller;
        var whiteList = field.getAttribute('data-white-list');
        var allowTagCreate = field.getAttribute('data-allow-create') == "false" ? false : true;

        if (whiteList == '' || whiteList == undefined || whiteList == null) {
            whiteList = [];
        } else {
            whiteList = JSON.parse(inputTag.getAttribute('data-white-list'));
        }

        var tagify = new Tagify(field, {
            autocomplete: true,
            whitelist: whiteList,
            addTagOnBlur: false,
            editTags: false,
            originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(',')
        });

        tagify.on('focus', e => {
            updateInputTagSuggestion('')
        })
        tagify.on('input', e => {
            var value = e.detail.value;
            updateInputTagSuggestion(value)
        })
        tagify.on('add', e => {
            if (allowTagCreate == false && tagify.settings.whitelist.length == 0) {
                tagify.removeTag(e.detail.tag)
            }
        })

        function updateInputTagSuggestion(value) {
            if (value != '') {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    fetchTagsRemote(value)
                }, 500);
            } else {
                fetchTagsRemote(value)
            }
        }

        function fetchTagsRemote(value) {
            tagify.settings.whitelist.length = 0;

            controller && controller.abort();
            controller = new AbortController();

            tagify.loading(true).dropdown.hide.call(tagify)

            fetch('/api/tags/autocomplete?q=' + value + '&type=' + field.getAttribute('data-type'), {
                signal: controller.signal,
                headers: getHeaders()
            }).then(res => res.json())
                .then(function (whitelist) {
                    // update inwhitelist Array in-place
                    tagify.settings.whitelist.splice(0, whitelist.length, ...whitelist)
                    tagify.loading(false).dropdown.show.call(tagify, value);
                })
                .catch(function (error) {
                    tagify.loading(false)
                });
        }
    }

    /**
     * Lecture automatique de code barre
     *
     * https://github.com/zxing-js/library
     */
    $(document).on('click', '.barcode-trigger', function () {
        $('#input-target').val('#' + $(this).data("target-input-id"));
        // data-camera="back" : privilégie la caméra arrière (tablette / mobile)
        const preferBackCamera = $(this).data('camera') === 'back';
        $('#barcode-reader-modal').modal({});

        const hints = new Map();
        const formats = [BarcodeFormat.CODE_128, BarcodeFormat.CODE_39, BarcodeFormat.CODE_93, BarcodeFormat.EAN_13, BarcodeFormat.EAN_8, BarcodeFormat.UPC_A, BarcodeFormat.UPC_E, BarcodeFormat.UPC_EAN_EXTENSION];
        hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);

        const codeReader = new BrowserMultiFormatReader(hints);

        navigator.mediaDevices.getUserMedia({ video: true }).then(() => {
            // Récupération des différentes sources
            codeReader.listVideoInputDevices().then((videoInputDevices) => {
                const sourceSelect = document.getElementById('sourceSelect')
                var selectedDeviceId;

                if (videoInputDevices.length > 0) {
                    const backCamera = preferBackCamera
                        ? videoInputDevices.find((device) => /back|rear|arri[eè]re|environment/i.test(device.label))
                        : null;
                    selectedDeviceId = (backCamera || videoInputDevices[0]).deviceId
                    startReader()
                }

                if (videoInputDevices.length >= 1) {
                    if (sourceSelect.length == 0) {
                        videoInputDevices.forEach((element) => {
                            const sourceOption = document.createElement('option');
                            sourceOption.text = element.label;
                            sourceOption.value = element.deviceId;
                            sourceSelect.appendChild(sourceOption)
                        })
                    }
                    sourceSelect.value = selectedDeviceId;

                    const sourceSelectPanel = document.getElementById('sourceSelectPanel');
                    sourceSelectPanel.style.display = 'block';

                    sourceSelect.onchange = () => {
                        selectedDeviceId = sourceSelect.value;
                        codeReader.reset();
                        startReader();
                    };
                }

                function startReader() {
                    codeReader.decodeFromVideoDevice(selectedDeviceId, 'video', (result, err) => {
                        if (result) {
                            let id = $('#input-target').val();
                            let target = $(id);
                            if (target.length) {
                                target.val(result.text);
                                target[0].dispatchEvent(new Event('input'));

                                if (id == '#badge') {
                                    $('#secret').focus();
                                } else if (id == '#lot') {
                                    document.dispatchEvent(new CustomEvent('lotSearchUpdated', { detail: result.text }));
                                } else if (id == '#intervention') {
                                    document.dispatchEvent(new CustomEvent('interventionSearchUpdated', { detail: result.text }));
                                } else if (id == '#search') {
                                    document.dispatchEvent(new CustomEvent('scanSearchUpdated', { detail: result.text }));
                                } else if (id == '#inventoryScanInput') {
                                    document.dispatchEvent(new CustomEvent('inventoryScanUpdated', { detail: result.text }));
                                }

                                if (target.data('is-autocomplete') == true) {
                                    target.data("ui-autocomplete")._search(result.text)
                                }
                            }

                            $('#barcode-reader-modal').modal('hide')
                        }
                        if (err && !(err instanceof NotFoundException)) {
                            console.log(err)
                        }
                    })
                }
            }).catch((err) => {
                console.error(err)
            })

            $('#barcode-reader-modal').on('hidden.bs.modal', function (e) {
                codeReader.reset()
                $('#input-target').val('')
            })
        })
    })

    /**
     * Lecteur ouvert par-dessus une autre modale (création d'article depuis une ligne) : il
     * passe devant, et la modale du dessous garde son défilement quand il se ferme.
     */
    $(document).on('show.bs.modal', '#barcode-reader-modal', function () {
        $(this).toggleClass('is-stacked', $('.modal.show').not(this).length > 0);
    });
    $(document).on('shown.bs.modal', '#barcode-reader-modal', function () {
        if ($(this).hasClass('is-stacked')) {
            $('.modal-backdrop').last().addClass('is-stacked');
        }
    });
    $(document).on('hidden.bs.modal', '#barcode-reader-modal', function () {
        if ($('.modal.show').length) {
            $('body').addClass('modal-open');
        }
    });

    /**
     * Sortable
     */
    var sortableContainers = document.getElementsByClassName('sortable-container');
    Array.prototype.forEach.call(sortableContainers, function (sortableContainer) {
        Sortable.create(sortableContainer, {
            ghostClass: 'ix-sortable-ghost-background',
            handle: '.handle',
            animation: 150,
            onEnd: function (e) {
                var dropEl = e.item;

                fetch(dropEl.dataset.moveUrl, {
                    headers: getHeaders(),
                    method: 'PUT',
                    body: JSON.stringify({ new_index: e.newIndex })
                }).then(res => res.json())
                    .catch(function (error) {
                        console.log(error)
                    });
            }
        });
    });

    /**
     * Bouton clipboard
     */
    $('.copy-button').click(function (e) {
        e.preventDefault()
        var target = $(this).data("target")
        var copyText = document.getElementById(target);
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
    })

    var previousInvoiceType = null;
    function updateInvoiceFormState() {
        const selectInvoiceType = $('.select-invoice-type');
        if (!selectInvoiceType.length) return;

        const newValue = selectInvoiceType.val();
        const typeChanged = previousInvoiceType !== null && previousInvoiceType !== newValue;
        previousInvoiceType = newValue;
        const target = $('#recurrences-informations');
        const percentBloc = $('#percent-bloc');
        const switchType = $('#change_type_invoiced');
        const linesBody = $('#invoice-lines-body');
        const fieldTotalHt = $('#total-ht-block');
        const advicePercentBlock = $('#advice-percent');
        const globalPercentageBlock = $('#global-percentage-block');
        const form = selectInvoiceType.closest("form");

        // Reset inputs only when type changes
        if (typeChanged) {
            $('#percent').val(100);
            $('#global_percentage').val(100);
            $('#deduct_acompte').prop('checked', false);
            switchType.prop('checked', false);
            $('#acompte_mode_switch').prop('checked', false);
            $('#acompte_mode_hidden').val('percent');
            $('#acompte-percent-input-block').show();
            $('#acompte-amount-input-block').hide();
            $('#acompte_amount').val('');
        }

        if (newValue == "2") {
            $('#name').prop('required', true);
            $('#periodicity').prop('required', true);
            $('#first_at').prop('required', true);
            form.attr('action', selectInvoiceType.data('recurrence-url-form'));
            $('#input_change_type_invoiced').hide();
            target.show();
            percentBloc.hide();
            linesBody.show();
            $('#acompte-preview').hide();
            $('#acompte-deduction-block').hide();
            $('#invoice-submit-btn').prop('disabled', false).removeClass('disabled');
            $('#invoice_total_ht').text($('#input_invoice_total_remaining').val() + '€');
            
            form.find('.quantity-field').show();
            form.find('.percentage-field').hide();
            globalPercentageBlock.hide();
        } else {
            $('#name').prop('required', false);
            $('#periodicity').prop('required', false);
            $('#first_at').prop('required', false);
            form.attr('action', selectInvoiceType.data('invoice-url-form'));
            $('#input_change_type_invoiced').show();
            target.hide();
            percentBloc.hide();

            var totalRemainingTotal = calculateTotalRemaining();
            var percent = $('#total-ht-block').length ? $('#percent').val() : 100;
            var finalRenderValue = ((percent * totalRemainingTotal) / 100).toFixed(2);
            $('#invoice_total_ht').text(formatCurrency(finalRenderValue));

            if (newValue == "1") {
                percentBloc.show();
                linesBody.hide();
                $('#acompte-preview').show();
                $('#acompte-deduction-block').hide();
                $('#input_change_type_invoiced').hide();
                fieldTotalHt.hide();
                advicePercentBlock.hide();
                globalPercentageBlock.hide();
                $('#progress-preview').hide();
                $('#normal-preview').hide();
                
                form.find('.quantity-field').show();
                form.find('.percentage-field').hide();
                updateAcomptePreview();
            } else {
                $('#acompte-preview').hide();
                $('#acompte-deduction-block').show();
                $('#invoice-submit-btn').prop('disabled', false).removeClass('disabled');
                $('#input_change_type_invoiced').show();
                fieldTotalHt.show();
                advicePercentBlock.show();

                const isProgressChecked = switchType.is(':checked');
                if (isProgressChecked) {
                    linesBody.show();
                    form.find('.quantity-field').hide();
                    form.find('.quantity-input').prop('required', false);
                    form.find('.percentage-field').show();
                    form.find('.percentage-input').prop('required', true);
                    globalPercentageBlock.show();
                    if (!$('#global_percentage').val()) {
                        $('#global_percentage').val(100);
                    }
                    $('#progress-preview').show();
                    $('#normal-preview').hide();
                    updateProgressPreview();
                } else {
                    linesBody.show();
                    form.find('.quantity-field').show();
                    form.find('.quantity-input').prop('required', true);
                    form.find('.percentage-field').hide();
                    form.find('.percentage-input').prop('required', false);
                    globalPercentageBlock.hide();
                    $('#progress-preview').hide();
                    $('#normal-preview').show();
                    updateNormalPreview();
                    $('#invoice-submit-btn').prop('disabled', false).removeClass('disabled');
                }
            }
        }
    }

    /**
     * Affichage ou non des champs pour la création facture récurrente
     */
    $('.select-invoice-type').change(function () {
        updateInvoiceFormState();
    });

    $('#change_type_invoiced').change(function (e){
        updateInvoiceFormState();
    });

    function applyGlobalPercentage(globalInput) {
        globalInput.closest('form').find('.percentage-input:not([readonly])').val(globalInput.val()).trigger('input');
        updateProgressPreview();
    }

    $(document).on('input', '#global_percentage', function() {
        applyGlobalPercentage($(this));
    });

   

    if($('#total-ht-block').length){
        $('#percent').on('input',function (e){
            let value = $(this).val();
            if(value){
                var totalRemainingTotal = calculateTotalRemaining();
                let finalRenderValue = ((value * totalRemainingTotal) / 100).toFixed(2);
                console.log(totalRemainingTotal, value, finalRenderValue);
                $('#invoice_total_ht').text(formatCurrency(finalRenderValue));
            }
            updateAcomptePreview();
        })
    }

    // Acompte mode toggle (percent / amount)
    $(document).on('change', '#acompte_mode_switch', function() {
        var isAmount = $(this).is(':checked');
        $('#acompte_mode_hidden').val(isAmount ? 'amount' : 'percent');
        if (isAmount) {
            $('#acompte-percent-input-block').hide();
            $('#acompte-amount-input-block').show();
        } else {
            $('#acompte-amount-input-block').hide();
            $('#acompte-percent-input-block').show();
        }
        updateAcomptePreview();
    });

    $(document).on('input', '#acompte_amount', function() {
        updateAcomptePreview();
    });

    $('#active_guarantee').change(function (e){
        let guaranteeBlock = $('#guarantee-block');
        let isChecked = $(this).is(':checked');
        if(isChecked){
            guaranteeBlock.show();
        } else {
            guaranteeBlock.hide();
        }
    })

    $('#deduct_acompte').change(function (e){
        let deductionInfo = $('#acompte-deduction-info');
        if($(this).is(':checked')){
            deductionInfo.show();
        } else {
            deductionInfo.hide();
        }
        updateNormalPreview();
        updateProgressPreview();
    })

    /**
     * Ouverture modal création de ligne de bl avec index
     */
    $('.add-delivery-line-index').click(function (e) {
        e.preventDefault()
        $('#position').val($(this).data('position'))
        $('#delivery_line').val($(this).data('delivery-line'))
        $('#addDeliveryLineModal').modal('show')
    })

    /**
     * Désactivation de l'envoi des formulaires à la soumission
     * Pour éviter le double envoi
     */
    $('form:not(.ajax-form)').submit(function (event) {
        if ($(this).hasClass('submitted')) {
            event.preventDefault();
        }
        else {
            event.preventDefault();

            if (!$(this).hasClass('refuse-quote-form') && !$(this).hasClass('delete-form') && !$(this).hasClass('duplicate-form') && !$(this).hasClass('confirm-form') && !$(this).hasClass('confirm-payment')) {
                disableSubmitButton(this)
                this.submit()
            }
        }
    });

    /**
     * Envoi requête serveur lors changement état switch
     */
    $('.toggle-remote').on('change', function (e) {
        let isChecked = $(this).prop('checked')
        let value = isChecked ? $(this).data('checked-value') : $(this).data('unchecked-value')

        if (!isChecked && $(this).data('delete-row')) {
            $(this).closest("tr").remove();
        }

        fetch($(this).data('url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ value: value })
        }).then(res => res.json())
            .catch(function (error) {
                console.log(error)
            });
    });

    /**
     * Ouverture modal renouvellement habilitation
     */
    $('.renew-ability').click(function (e) {
        e.preventDefault()
        let formUrl = $(this).data('form-url');
        let passAt = $(this).data('pass-at');

        $('#renewAbilityForm').attr('action', formUrl)
        $('#form_url').val(formUrl)
        $('#old_pass_at').val(passAt)

        $('#new_pass_at').data('date-start-date', passAt)
        $('#new_pass_at').datepicker('setStartDate', passAt);

        $('#renewAbilityModal').modal('show')
    })

    $('.history-ability').click(function (e) {
        e.preventDefault()
        let el = $(this)
        el.html('<i class="far fa-circle-notch fa-spin"></i>')
        el.prop("disabled", true)


        fetch(el.data('url'), {
            headers: getHeaders(),
            method: 'GET'
        }).then(function (response) {
            el.html('<i class="far fa-history"></i> Historique de passage')
            el.prop("disabled", false)

            if (response.status == 200) {
                response.json().then(function (data) {
                    let table = document.getElementById('ability-dates-list');
                    table.innerHTML = ""

                    data.forEach(date => {
                        table
                            .insertRow(-1)
                            .innerHTML = "<td>" + date + "</td>";
                    })

                    $('#historyAbilityModal').modal('show')
                })
            } else {
                alertError(null)
            }
        }).catch(function (error) {
            alertError(null)
            el.html('<i class="far fa-history"></i> Historique de passage')
            el.prop("disabled", false)
        });
    })

    $('.quantity-toggler').click(function (e) {
        const targetInput = $('#' + $(this).data('target-input'))
        var value = targetInput.val()
        if ($(this).data('operation') == 'add') {
            value++;
        } else {
            value--
        }

        targetInput.val(value)
    });

    /**
     * Modal de signature
     */
    $('.add-signature').click(function (e) {
        $('#input_target').val($(this).data('input-target'))
        $('#img_target').val($(this).data('img-target'))
        $('#original_sign').val($('#' + $(this).data('input-target')).val())
    })

    let signaturePad;
    $('#signModal').on('shown.bs.modal', function (e) {
        let canvas = $("#signature-pad canvas");
        let parentWidth = $(canvas).parent().outerWidth();
        canvas.attr("width", parentWidth + 'px');
        signaturePad = new SignaturePad(canvas[0]);

        if ($('#original_sign').val()) {
            signaturePad.fromDataURL($('#original_sign').val())
        }
    })

    $('#signModal').on('hidden.bs.modal', function (e) {
        signaturePad.clear();
    });

    $(document).on('click', '#signModal .clear-sign', function () {
        signaturePad.clear();
    });

    $(document).on('click', '#signModal .save-sign', function () {
        if (signaturePad.isEmpty()) {
            $('#' + $('#input_target').val()).val('')
            $('#' + $('#img_target').val()).attr('src', '');
        } else {
            let dataURL = signaturePad.toDataURL();
            $('#' + $('#input_target').val()).val(dataURL)
            $('#' + $('#img_target').val()).attr('src', dataURL);
        }

        $('#signModal').modal('hide');
    });

    $('#toggle-list-filters').on('click', function (e) {
        $(this).blur()
        if ($('#list-filters').is(":visible")) {
            $('#list-filters').hide();
        } else {
            $('#list-filters').show();
        }
    });

    $('.trigger-sidebar').on('click', function (e) {
        $('#' + $(this).data('target')).toggleClass('open')
    });

    $('.trigger-close-sidebar').on('click', function (e) {
        $(this).closest('.ix-sidebar').removeClass('open')
    });

    $('.ix-table-btn-order').on('click', function (e) {
        e.preventDefault();
        const orderInputField = $('#orderBy');
        orderInputField.val($(this).data('order-value'));

        const form = orderInputField.closest('form');
        form.submit();
    });

    $('#create-invoice-modal').on('click', function (e) {
        e.preventDefault()
        openProcessLineModal('createInvoiceModal', 'invoice')
    });

    // Reset delivery generation for acompte and recurring invoice types
    $('#type').on('change', function() {
        if ($(this).val() !== '0') {
            $('#generate_delivery').val('0');
        }
    });

    // Swal de confirmation pour la génération du BL lors de la facturation
    $('#invoice-submit-btn').on('click', function(e) {
        var generateInput = $('#generate_delivery');
        // Pas de hidden input generate_delivery => pas de flow BL activé, on laisse passer
        if (generateInput.length === 0) {
            return;
        }
        // Valeur déjà "1" (re-population après erreur) => on laisse passer
        if (generateInput.val() === '1') {
            return;
        }
        // Type non classique (acompte/récurrent) => pas de BL, on laisse passer
        if ($('#type').val() !== '0') {
            return;
        }

        e.preventDefault();
        Swal.fire({
            title: 'Générer un bon de livraison ?',
            text: "Un bon de livraison sera créé en \"En cours\" et passera en \"Livré\" lors de la validation de la facture.",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Oui',
            cancelButtonText: 'Non',
            reverseButtons: true,
            heightAuto: false,
            customClass: {
                actions: 'ix-swal-actions-inline'
            }
        }).then(function(result) {
            generateInput.val(result.value ? '1' : '0');
            $('#createInvoiceModal form').off('submit').submit();
        });
    });

    $('#create-delivery-modal').on('click', function (e) {
        e.preventDefault()
        openProcessLineModal('createDeliveryModal', 'delivery')
    });

    // Initialize SN handlers when modal is shown via modalError (repopulated old lines after validation failure)
    $('#createDeliveryModal').on('shown.bs.modal', function() {
        $(this).find('.sn-input-wrapper').each(function() {
            initSnInputHandlersFromWrapper($(this));
        });
    });

    $('#createInvoiceModal').on('shown.bs.modal', function() {
        $(this).find('.sn-input-wrapper').each(function() {
            initSnInputHandlersFromWrapper($(this));
        });
    });

    $('#lot-ventilation-modal').on('click', function(e) {
        e.preventDefault();
        openProcessLotModal('lotVentilationModal');
    })

    // Gestion des tags sur le tableau des achats de frais généraux
    $('.ix-tag-purchase').on('click', function (e) {
        var form = $(e.target).parent().parent().find('form')
        form.parent().find('.ix-tag-purchase').hide();
        form.css({ 'display': 'block' });

        form.find('button').on('click', function (event) {
            form.submit();
        })
    });


    var inputInjectPrediction = $('input[type=radio][name=inject_prediction]');
    inputInjectPrediction.on('change', function (e) {
        if (this.value == '1')
            $('.inject-prediction-remaining').css('display', 'block')
        else
            $('.inject-prediction-remaining').css('display', 'none')
    })

    function openProcessLotModal(modal){
        $('#' + modal).modal('show');


        // Suppression des précédents inputs de la modale de création de la facture
        const formLinesContainer = $('#' + modal).find($('.form-lines-container'))
        formLinesContainer.html('')

        // Récupération du nombre de lignes sélectionnées
        const checkboxes = $('.check-all-container-dealPurchases').find($("input[type=\"checkbox\"]:checked"));

        if (checkboxes.length > 0) {
            $('#' + modal).find($('table')).show()
            $('#' + modal).find($('.alert')).hide()
            $('#' + modal).find($('.save')).attr('disabled', false)
            

            checkboxes.each(function () {
                var id = $(this).val();
                var reference = $(this).data('reference');
                var purchaseId = $(this).data('purchase-id');
                var expense = $(this).data('expense');
                var expenseId = $(this).data('expense-id');
                var designation = $(this).data('designation');
                var suggestedPurchaseQuantity = $(this).data('suggested-purchase-quantity'); 
                var originalQuantity = $(this).data('quantity');
                var totalAfterDiscount = $(this).data('total_after_discount');
                var totalTtc = $(this).data('total_ttc');

                var row = `<tr>
                            <td>
                                <input type="hidden" name="dealPurchases[${id}][id]" value="${id}">
                                <input type="hidden" name="dealPurchases[${id}][purchase_id]" value="${purchaseId}">
                                <input type="hidden" name="dealPurchases[${id}][expense_id]" value="${expenseId}">
                                <input type="hidden" name="dealPurchases[${id}][reference]" value="${reference}">
                                <input type="hidden" name="dealPurchases[${id}][designation]" value="${designation}">
                                <input type="hidden" name="dealPurchases[${id}][original_quantity]" value="${originalQuantity}">
                                <input type="hidden" name="dealPurchases[${id}][total_ttc]" value="${totalTtc}">
                                <input type="hidden" name="dealPurchases[${id}][total_after_discount]" value="${totalAfterDiscount}">
                                ${expense}
                            </td>`
                row += `<td>${reference}</td><td>${designation}</td>
                        <td>
                            <input type="number" class="form-control form-control-sm text-center" max="${originalQuantity}" value="${suggestedPurchaseQuantity}" name="dealPurchases[${id}][quantity]" required step="0.001">
                        </td>`

                formLinesContainer.append(row)
            })
        } else {
            $('#' + modal).find($('table')).hide()
            $('#' + modal).find($('.alert')).show()
            $('#' + modal).find($('.save')).attr('disabled', true)
        }


    }

    /**
     * Détail d'un article composé dans les formulaires de livraison (modale de création,
     * réception) : la rangée [data-kit-row] porte la composition figée, la quantité vient du
     * champ [data-kit-quantity] de la même ligne. Jamais sur les PDF.
     */
    function renderKitDetail($row) {
        var lineId = $row.data('kit-row');
        var components = $row.data('kit-components') || [];
        var quantity = parseFloat($('[data-kit-quantity="' + lineId + '"]').val()) || 0;
        var format = function (value) {
            return (parseFloat(value) || 0).toFixed(3).replace(/\.?0+$/, '').replace('.', ',');
        };
        var text = function (value) {
            return $('<div>').text(value === null || value === undefined ? '' : value).html();
        };

        var html = '<table class="ix-table ix-table-sm"><thead><tr>' +
            '<th>Référence</th><th>Désignation</th><th class="text-right">Qté / kit</th><th>Unité</th><th class="text-right">Qté totale</th>' +
            '</tr></thead><tbody>';
        components.forEach(function (component) {
            html += '<tr><td>' + text(component.number || '-') + '</td><td>' + text(component.name) + '</td>' +
                '<td class="text-right">' + format(component.quantity) + '</td><td>' + text(component.unit || 'U') + '</td>' +
                '<td class="text-right">' + format(component.quantity * quantity) + '</td></tr>';
        });
        html += '</tbody></table>';

        $row.children('td').html(html);
    }

    // [data-kit-detail] : le même détail rendu par le serveur sur les fiches, sans quantité à suivre.
    $(document).on('click', '[data-kit-toggle]', function () {
        var lineId = $(this).data('kit-toggle');
        $('[data-kit-row="' + lineId + '"], [data-kit-detail="' + lineId + '"]').toggleClass('d-none');
        $(this).toggleClass('is-open');
    });

    $(document).on('input change', '[data-kit-quantity]', function () {
        $('[data-kit-row="' + $(this).data('kit-quantity') + '"]').each(function () {
            renderKitDetail($(this));
        });
    });

    $('[data-kit-row]').each(function () {
        renderKitDetail($(this));
    });

    function initSnInputHandlers(lineId, modalId) {
        // Une ligne de kit a un bloc par composant à numéros.
        $('#' + modalId).find('.sn-input-wrapper[data-line-id="' + lineId + '"]').each(function () {
            initSnInputHandlersFromWrapper($(this));
        });
    }

    /** Le nombre de numéros attendus pour un composant de kit : un par unité entière de kits × quantité par kit. */
    function kitSerialCount(kits, perKit) {
        return Math.max(0, Math.floor(Math.round((parseFloat(kits) || 0) * (parseFloat(perKit) || 0) * 1e6) / 1e6));
    }

    /** Les blocs de saisie des numéros d'une ligne de kit dans une modale, un par composant à numéros. */
    function kitSerialRows(lineId, components, kits, colspan) {
        var text = function (value) {
            return $('<div>').text(value === null || value === undefined ? '' : value).html();
        };

        return (components || []).filter(function (component) {
            return component.has_serial_numbers;
        }).map(function (component) {
            var expected = kitSerialCount(kits, component.quantity);

            return '<tr class="sn-row" data-line-id="' + lineId + '">' +
                '<td colspan="' + colspan + '" style="padding: 8px 16px 8px 16px;">' +
                    '<div class="sn-input-wrapper" data-line-id="' + lineId + '" data-article-id="' + component.article_id + '" data-component-id="' + component.article_id + '" data-sn-per-kit="' + component.quantity + '" data-sn-qty="' + expected + '">' +
                        '<div class="small text-muted mb-1"><i class="far fa-barcode mr-1"></i>' + text(component.name) + '</div>' +
                        '<div class="input-group input-group-sm mb-1">' +
                            '<input type="text" class="form-control sn-entry-input" placeholder="Scanner ou saisir un N° de série" data-line-id="' + lineId + '">' +
                            '<div class="input-group-append">' +
                                '<button type="button" class="btn btn-outline-secondary sn-add-btn"><i class="fas fa-plus"></i></button>' +
                            '</div>' +
                        '</div>' +
                        '<div class="sn-list-container" style="max-height: 120px; overflow-y: auto;"></div>' +
                        '<small class="sn-counter text-muted">0 / ' + expected + '</small>' +
                    '</div>' +
                '</td>' +
            '</tr>';
        }).join('');
    }

    function initSnInputHandlersFromWrapper($wrapper) {
        if ($wrapper.length === 0) return;
        if ($wrapper.data('sn-initialized')) return;
        $wrapper.data('sn-initialized', true);

        var lineId = $wrapper.data('line-id');
        var $entryInput = $wrapper.find('.sn-entry-input');
        var $addBtn = $wrapper.find('.sn-add-btn');
        var $listContainer = $wrapper.find('.sn-list-container');
        var $counter = $wrapper.find('.sn-counter');
        var snQty = parseInt($wrapper.data('sn-qty')) || 0;
        var articleId = $wrapper.data('article-id');
        // Composant d'un kit : chaque numéro est posté avec son composant, l'attendu suit kits × quantité par kit.
        var componentId = $wrapper.data('component-id');
        var perKit = $wrapper.data('sn-per-kit');
        var snList = [];
        $wrapper.data('sn-list', snList);

        // Un numéro ne sort qu'une fois : ceux déjà pris par un autre bloc du même article (deux kits qui partagent un composant).
        function takenElsewhere() {
            var taken = [];
            $wrapper.closest('form').find('.sn-input-wrapper[data-article-id="' + articleId + '"]').not($wrapper).each(function () {
                taken = taken.concat($(this).data('sn-list') || []);
            });
            return taken;
        }

        function escapeHtml(str) {
            return String(str).replace(/[&<>"']/g, function(c) {
                return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
            });
        }

        function updateCounter() {
            $counter.text(snList.length + ' / ' + snQty);
            if (snList.length === snQty) {
                $counter.removeClass('text-muted').addClass('text-success');
            } else {
                $counter.removeClass('text-success').addClass('text-muted');
            }
        }

        function renderList() {
            $listContainer.empty();
            snList.forEach(function(sn, index) {
                var $item = $('<div class="d-flex align-items-center justify-content-between py-1 px-2 mb-1" style="background: #f8f9fa; border-radius: 4px; font-size: 0.85rem;">' +
                    '<span><i class="far fa-barcode text-muted mr-1"></i>' + escapeHtml(sn) + '</span>' +
                    '<button type="button" class="btn btn-sm text-danger p-0 ml-2 sn-remove-btn" data-index="' + index + '" style="line-height: 1;"><i class="fas fa-times"></i></button>' +
                    '</div>');
                $listContainer.append($item);
            });
            $wrapper.find('.sn-hidden-inputs').remove();
            var $hiddenContainer = $('<div class="sn-hidden-inputs" style="display:none;"></div>');
            snList.forEach(function(sn, index) {
                if (componentId) {
                    var key = 'lines[' + lineId + '][serial_numbers][' + componentId + '_' + index + ']';
                    $hiddenContainer.append('<input type="hidden" name="' + key + '[serial_number]" value="' + escapeHtml(sn) + '">');
                    $hiddenContainer.append('<input type="hidden" name="' + key + '[article_id]" value="' + componentId + '">');
                    return;
                }
                $hiddenContainer.append('<input type="hidden" name="lines[' + lineId + '][serial_numbers][' + index + '][serial_number]" value="' + escapeHtml(sn) + '">');
            });
            $wrapper.append($hiddenContainer);
            updateCounter();
        }

        function addSn() {
            var value = $entryInput.val().trim();
            if (!value) return;
            if (snList.length >= snQty) {
                $entryInput.addClass('is-invalid');
                setTimeout(function() { $entryInput.removeClass('is-invalid'); }, 1000);
                return;
            }
            if (snList.indexOf(value) !== -1 || takenElsewhere().indexOf(value) !== -1) {
                $entryInput.addClass('is-invalid');
                setTimeout(function() { $entryInput.removeClass('is-invalid'); }, 1000);
                return;
            }
            snList.push(value);
            $entryInput.val('').focus();
            renderList();
        }

        // jQuery UI autocomplete for serial numbers
        if (articleId && typeof $.ui !== 'undefined' && $.ui.autocomplete) {
            $entryInput.autocomplete({
                source: function(request, response) {
                    $.ajax({
                        url: '/api/articles/' + articleId + '/serial-numbers',
                        data: { q: request.term },
                        dataType: 'json',
                        headers: getHeaders(),
                        success: function(data) {
                            var taken = snList.concat(takenElsewhere());
                            response($.map(data, function(item) {
                                if (taken.indexOf(item.serial_number) !== -1) return null;
                                return { label: item.serial_number, value: item.serial_number };
                            }));
                        }
                    });
                },
                minLength: 1,
                delay: 200,
                appendTo: $wrapper,
                select: function(event, ui) {
                    $entryInput.val(ui.item.value);
                    addSn();
                    return false;
                }
            });
        }

        $entryInput.on('keydown', function(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                if ($entryInput.autocomplete('instance') && $entryInput.autocomplete('instance').menu.active) return;
                addSn();
            }
        });

        $addBtn.on('click', function(e) {
            e.preventDefault();
            addSn();
        });

        $listContainer.on('click', '.sn-remove-btn', function(e) {
            e.preventDefault();
            snList.splice(parseInt($(this).data('index')), 1);
            renderList();
        });

        // Update snQty when the quantity input for this line changes
        var $qtyInput = $wrapper.closest('.modal').find('input[name="lines[' + lineId + '][quantity]"]');
        $qtyInput.on('input change', function() {
            var newQty = componentId ? kitSerialCount($(this).val(), perKit) : (parseInt($(this).val()) || 0);
            snQty = newQty;
            $wrapper.data('sn-qty', newQty);
            renderList();
        });

        updateCounter();

        // Load preset values from data-preset (for repopulated old lines)
        var preset = $wrapper.data('preset');
        if (preset && Array.isArray(preset)) {
            preset.forEach(function(sn) {
                if (snList.length < snQty) snList.push(sn);
            });
            renderList();
        }
    }

    // Éco-participations : cochées avec leur article, jamais seules (ni sans article valide)
    function syncEcoParticipationSelection() {
        const container = $('.check-all-container-lines');
        container.find('input.check-one').each(function () {
            if (parseInt($(this).data('is-eco')) !== 1) return;
            const parentId = $(this).data('eco-parent-line-id');
            const parent = parentId ? container.find('input.check-one[value="' + parentId + '"]') : $();
            $(this).prop('checked', parent.length > 0 && parent.is(':checked'));
        });
    }

    // Quantité d'une éco-participation : celle de son article × ratio des quantités commandées
    function syncEcoFollowQuantities(formLinesContainer) {
        formLinesContainer.find('[data-eco-parent-line-id]').each(function () {
            const parentId = $(this).data('eco-parent-line-id');
            const ratio = parseFloat($(this).data('eco-ratio')) || 0;
            const parentInput = formLinesContainer.find('input[name="lines[' + parentId + '][quantity]"]');
            // Article du détail d'un lot sans champ quantité : le serveur livre le reste à livrer
            const parentQuantity = parentInput.length
                ? parseFloat(parentInput.val()) || 0
                : parseFloat($('.check-all-container-lines').find('input.check-one[value="' + parentId + '"]').data('suggested-delivery-quantity')) || 0;
            const quantity = parseFloat((parentQuantity * ratio).toFixed(3));
            if ($(this).is('input')) {
                $(this).val(quantity);
            } else {
                $(this).text(quantity);
            }
        });
    }

    function openProcessLineModal(modal, type) {
        // Suppression des précédents inputs de la modale de création de la facture
        const formLinesContainer = $('#' + modal).find($('.form-lines-container'))
        formLinesContainer.html('')

        syncEcoParticipationSelection();

        // Récupération du nombre de lignes sélectionnées
        const checkboxes = $('.check-all-container-lines').find($("input[type=\"checkbox\"]:checked"));

        if (checkboxes.length > 0) {
            $('#' + modal).find($('table')).show()
            $('#' + modal).find($('.alert')).hide()

            checkboxes.each(function () {
                var id = $(this).val();
                var isTitle = $(this).data('is-title');
                var reference = $(this).data('reference');
                var designation = $(this).data('designation');
                var unit = $(this).data('unit');
                var suggestedInvoiceQuantity = $(this).data('suggested-invoice-quantity');
                var suggestedDeliveryQuantity = $(this).data('suggested-delivery-quantity');
                var originalQuantity = $(this).data('quantity');
                var deliveredQuantity = $(this).data('delivered-quantity');
                var invoicedQuantity = $(this).data('invoiced-quantity');
                var articleId = $(this).data('article_id');
                var hasSerialNumbers = $(this).data('has-serial-numbers') === 1 || $(this).data('has-serial-numbers') === '1' || $(this).attr('data-has-serial-numbers') === '1';
                // Un kit se déplie à la livraison seulement : la facture n'a que faire de ses composants, sauf pour leurs numéros.
                var kitData = $(this).data('kit-components') || [];
                var kitComponents = type == 'invoice' || kitData.length === 0 ? null : kitData;
                // À la facture, les numéros d'un kit ne servent qu'au BL qu'elle génère : jamais si le réglage l'exclut.
                var invoiceWithoutDelivery = type == 'invoice' && String($('#' + modal).find('form').data('delivery-flow')) === '0';
                var kitHasSerials = !invoiceWithoutDelivery && kitData.some(function (component) { return component.has_serial_numbers; });
                var kitToggle = kitComponents ? '<button type="button" class="ix-kit-toggle mr-1" data-kit-toggle="' + id + '" title="Article composé · ' + kitComponents.length + ' composant' + (kitComponents.length > 1 ? 's' : '') + '"><i class="far fa-cubes"></i><i class="far fa-angle-down ml-1"></i></button>' : '';
                var kitQuantity = kitComponents ? 'data-kit-quantity="' + id + '"' : '';

                // Livraison : un véritable article du détail d'un lot semi-détaillé n'affiche pas de quantité
                // (le serveur reprend alors la quantité de la ligne de commande)
                var hidesDeliveryQuantity = type == 'delivery' && $(this).data('lot-detail-article') == 1;
                // Livraison : seule la ligne principale d'un lot est en gras, les autres lignes du lot restent en graisse normale
                var isDeliveryLotMain = type == 'delivery' && $(this).data('lot-main') == 1;
                var isDeliveryLotLine = type == 'delivery' && $(this).data('lot-line') == 1;
                var deliveryDesignation = isDeliveryLotMain
                    ? `<span class="ix-text-bold">${designation}</span>`
                    : designation;
                var titleDesignation = isDeliveryLotMain
                    ? `<span class="ix-text-bold">${designation}</span>`
                    : (isDeliveryLotLine ? designation : `<span class="ix-trade-line-title">${designation}</span>`);
                // L'icône de la ligne, comme sur les fiches ; un kit sans détail à déplier garde l'icône simple.
                var staticIcon = kitData.length > 0
                    ? '<i class="far fa-cubes ix-text-blue mr-1" title="Article composé"></i>'
                    : (articleId ? '<i class="far fa-cube ix-text-secondary mr-1" title="Article"></i>' : '');
                var ecoIcon = '<i class="far fa-recycle ix-text-secondary mr-1" title="Éco-participation"></i>';
                
                var suggestedQty = (type == 'invoice' ? suggestedInvoiceQuantity : suggestedDeliveryQuantity);
                var percent = originalQuantity > 0 ? parseFloat(((suggestedQty / originalQuantity) * 100).toFixed(2)) : 0;

                var row = `<tr>
                            <td>
                                <input type="hidden" name="lines[${id}][id]" value="${id}">
                                <input type="hidden" name="lines[${id}][is_title]" value="${isTitle}">
                                <input type="hidden" name="lines[${id}][reference]" value="${reference}">
                                <input type="hidden" name="lines[${id}][designation]" value="${designation}">
                                <input type="hidden" name="lines[${id}][original_quantity]" value="${originalQuantity}">
                                <input type="hidden" name="lines[${id}][unit]" value="${unit}">
                                <input type="hidden" name="lines[${id}][delivered_quantity]" value="${deliveredQuantity}">
                                <input type="hidden" name="lines[${id}][invoiced_quantity]" value="${invoicedQuantity}">
                                <input type="hidden" name="lines[${id}][article_id]" value="${articleId}">
                                <input type="hidden" name="lines[${id}][has_serial_numbers]" value="${hasSerialNumbers || kitHasSerials ? 1 : 0}">
                                ${reference}
                            </td>`

                var isEco = parseInt($(this).data('is-eco')) === 1;

                if (isEco) {
                    // Éco-participation : jamais saisie, sa quantité suit celle de son article
                    const ecoData = `data-eco-parent-line-id="${$(this).data('eco-parent-line-id')}" data-eco-ratio="${$(this).data('eco-ratio')}"`;

                    if (type == 'invoice') {
                        row += `<td>${ecoIcon}${designation}</td>
                            <td class="quantity-field"><input type="number" class="form-control form-control-sm quantity-input" value="0" name="lines[${id}][quantity]" step="0.001" readonly style="background-color: #e9ecef; pointer-events: none;" data-line-id="${id}" data-original-quantity="${originalQuantity}" data-invoiced-quantity="${invoicedQuantity}" ${ecoData}></td>
                            <td class="percentage-field"></td>`;
                    } else {
                        row += `<td>${ecoIcon}${deliveryDesignation}</td>
                            <td><span ${ecoData}>0</span></td>`;
                    }

                    row += `<td class="text-center">${originalQuantity} ${unit}</td>
                        <td class="text-center">${deliveredQuantity}</td>
                        <td class="text-center">${invoicedQuantity}</td></tr>`
                } else if (!isTitle && !hidesDeliveryQuantity) {
                   
                    const isReadonly = originalQuantity <= 0 ? 'readonly style="background-color: #e9ecef; pointer-events: none;"' : '';
                    const quantityInput = `<input type="number" class="form-control form-control-sm quantity-input" value="${suggestedQty}" name="lines[${id}][quantity]" required step="0.001" data-line-id="${id}" data-original-quantity="${originalQuantity}" data-invoiced-quantity="${invoicedQuantity}" data-suggested-quantity="${suggestedQty}" ${kitQuantity} ${isReadonly}>`;

                    row += `<td>${kitToggle || staticIcon}${deliveryDesignation}</td>`;

                    // La facturation à l'avancement (%) ne concerne que la facture
                    if (type == 'invoice') {
                        row += `<td class="quantity-field">${quantityInput}</td>
                            <td class="percentage-field">
                                <div class="input-group input-group-sm">
                                    <input type="number" class="form-control percentage-input" value="${percent}" name="lines[${id}][percentage]" min="0" step="0.01" data-line-id="${id}" data-original-quantity="${originalQuantity}" data-invoiced-quantity="${invoicedQuantity}" data-suggested-percentage="${percent}" ${isReadonly}>
                                    <div class="input-group-append">
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </td>`;
                    } else {
                        row += `<td>${quantityInput}</td>`;
                    }

                    row += `<td class="text-center">${originalQuantity} ${unit}</td>
                     
                        <td class="text-center">${deliveredQuantity}</td>
                        <td class="text-center">${invoicedQuantity}</td></tr>`

                    if (kitComponents) {
                        row += '<tr class="ix-table-row-secondary d-none" data-kit-row="' + id + '" data-kit-components="' + $('<div>').text(JSON.stringify(kitComponents)).html().replace(/"/g, '&quot;') + '"><td colspan="6"></td></tr>';
                    }

                    // SN row below the line (for articles with serial numbers)
                    if (hasSerialNumbers && articleId) {
                        var snQty = parseInt(type == 'invoice' ? suggestedInvoiceQuantity : suggestedDeliveryQuantity) || 0;
                        var snRow = '<tr class="sn-row" data-line-id="' + id + '">' +
                            '<td colspan="6" style="padding: 8px 16px 8px 16px;">' +
                                '<div class="sn-input-wrapper" data-line-id="' + id + '" data-article-id="' + articleId + '" data-sn-qty="' + snQty + '">' +
                                    '<div class="input-group input-group-sm mb-1">' +
                                        '<input type="text" class="form-control sn-entry-input" placeholder="Scanner ou saisir un N° de série" data-line-id="' + id + '">' +
                                        '<div class="input-group-append">' +
                                            '<button type="button" class="btn btn-outline-secondary sn-add-btn"><i class="fas fa-plus"></i></button>' +
                                        '</div>' +
                                    '</div>' +
                                    '<div class="sn-list-container" style="max-height: 120px; overflow-y: auto;"></div>' +
                                    '<small class="sn-counter text-muted">0 / ' + snQty + '</small>' +
                                '</div>' +
                            '</td>' +
                        '</tr>';
                        row += snRow;
                    }

                    if (kitHasSerials) {
                        row += kitSerialRows(id, kitData, type == 'invoice' ? suggestedInvoiceQuantity : suggestedDeliveryQuantity, 6);
                    }
                } else {
                    row += `<td colspan="5">${isTitle ? '' : staticIcon}${titleDesignation}</td></tr>`
                }

                formLinesContainer.append(row);
                if (!isTitle) {
                    checkExceeded(id);
                }

                if (kitComponents) {
                    renderKitDetail(formLinesContainer.find('[data-kit-row="' + id + '"]'));
                }

                // Initialize SN input handlers for both delivery and invoice modals
                if (!isTitle && ((hasSerialNumbers && articleId) || kitHasSerials)) {
                    initSnInputHandlers(id, modal);
                }
            })

            syncEcoFollowQuantities(formLinesContainer);
            formLinesContainer.off('input.ecoFollow').on('input.ecoFollow', '.quantity-input, .percentage-input', function () {
                // Après la mise à jour quantité ↔ pourcentage de la ligne article
                setTimeout(function () {
                    syncEcoFollowQuantities(formLinesContainer);
                    if (type == 'invoice') {
                        updateProgressPreview();
                        updateNormalPreview();
                    }
                }, 0);
            });
        } else {
            $('#invoice-lines-body').find($('table')).hide()
            $('#' + modal).find($('.alert')).show()
        }

        // Fonction pour vérifier le dépassement des valeurs suggérées
        function checkExceeded(lineId) {
            const qtyInput = $(`input[name="lines[${lineId}][quantity]"]`);
            const pctInput = $(`input[name="lines[${lineId}][percentage]"]`);
            
            const quantity = parseFloat(qtyInput.val()) || 0;
            const percentage = parseFloat(pctInput.val()) || 0;
            
            const suggestedQty = parseFloat(qtyInput.attr('data-suggested-quantity')) || 0;
            const suggestedPct = parseFloat(pctInput.attr('data-suggested-percentage')) || 0;
            
            // Tolérance d'arrondi de 0.001 pour les quantités et 0.01 pour les pourcentages
            const isQtyExceeded = quantity > (suggestedQty + 0.001);
            const isPctExceeded = percentage > (suggestedPct + 0.01);
        }

        // Type de facture (facture, acompte, récurrente) : uniquement pour la modale de facturation
        if (type == 'invoice') {
            $('.select-invoice-type').off('change.invoice_lines').on('change.invoice_lines', function () {
                const selectedType = $(this).val();
                checkboxes.each(function () {
                    const id = $(this).val();
                    const originalQuantity = $(this).data('quantity');
                    const suggestedInvoiceQuantity = $(this).data('suggested-invoice-quantity');
                    const qtyInput = formLinesContainer.find('input[name="lines[' + id + '][quantity]"]');
                    const pctInput = formLinesContainer.find('input[name="lines[' + id + '][percentage]"]');

                    qtyInput.attr('data-suggested-quantity', suggestedInvoiceQuantity);
                    pctInput.attr('data-suggested-percentage', originalQuantity > 0 ? parseFloat(((suggestedInvoiceQuantity / originalQuantity) * 100).toFixed(2)) : 0);

                    qtyInput.val(selectedType == "1" ? originalQuantity : suggestedInvoiceQuantity);
                    qtyInput.trigger('input');
                });
                updateInvoiceFormState();
            });

            updateInvoiceFormState();

            // Réouverture en facturation à l'avancement : les lignes reconstruites reprennent le pourcentage global
            if ($('#change_type_invoiced').is(':checked') && $('#global_percentage').val() !== '') {
                applyGlobalPercentage($('#global_percentage'));
            }
        }

        // Gestion du calcul automatique quantité ↔ pourcentage (namespacé : un seul écouteur malgré les ouvertures successives)
        $(document).off('input.processLines', '.percentage-input').on('input.processLines', '.percentage-input', function() {
            if ($(this).is('[readonly]')) return;
            const lineId = $(this).data('line-id');
            const originalQuantity = parseFloat($(this).data('original-quantity')) || 0;
            const percentage = parseFloat($(this).val()) || 0;
            const calculatedQuantity = originalQuantity * percentage / 100;
            // Affiche sans décimales inutiles : 1 au lieu de 1.000
            $(this).closest('form').find(`input[name="lines[${lineId}][quantity]"]`).val(parseFloat(calculatedQuantity.toFixed(3)));
            updateProgressPreview();
            updateNormalPreview();
            checkExceeded(lineId);
        });

        $(document).off('input.processLines', '.quantity-input').on('input.processLines', '.quantity-input', function() {
            const lineId = $(this).data('line-id');
            const originalQuantity = parseFloat($(this).data('original-quantity')) || 0;
            if (originalQuantity <= 0) return;
            const quantity = parseFloat($(this).val()) || 0;
            const calculatedPercentage = originalQuantity > 0 ? (quantity / originalQuantity) * 100 : 0;
            // Affiche sans décimales inutiles : 50 au lieu de 50.00
            $(this).closest('form').find(`input[name="lines[${lineId}][percentage]"]`).val(parseFloat(calculatedPercentage.toFixed(2)));
            updateProgressPreview();
            updateNormalPreview();
            checkExceeded(lineId);
        });

        $('#' + modal).modal('show');
    }

    $('#create-credit-note-modal').on('click', function (e) {
        e.preventDefault()
        const formLinesContainer = $('#cancelInvoiceModal').find($('.form-lines-container'))
        formLinesContainer.html('')

        // Récupération du nombre de lignes sélectionnées
        const checkboxes = $('.check-all-container-lines').find($("input[type=\"checkbox\"]:checked"));

        if (checkboxes.length > 0) {
            $('#cancelInvoiceModal').find($('table')).show()
            $('#cancelInvoiceModal').find($('.alert')).hide()

            checkboxes.each(function () {
                var id = $(this).val();
                var isTitle = $(this).data('is-title');
                var reference = $(this).data('reference');
                var designation = $(this).data('designation');
                var unit = $(this).data('unit');
                var originalQuantity = $(this).data('quantity');
                var hasSerialNumbers = $(this).data('has-serial-numbers');

                var row = `<tr class="cancel-line-row" data-line-id="${id}" data-has-serial-numbers="${hasSerialNumbers}">
                            <td>
                                <input type="hidden" name="lines[${id}][id]" value="${id}">
                                <input type="hidden" name="lines[${id}][is_title]" value="${isTitle}">
                                <input type="hidden" name="lines[${id}][reference]" value="${reference}">
                                <input type="hidden" name="lines[${id}][designation]" value="${designation}">
                                <input type="hidden" name="lines[${id}][original_quantity]" value="${originalQuantity}">
                                <input type="hidden" name="lines[${id}][unit]" value="${unit}">
                                ${reference}
                            </td>`

                if (!isTitle) {
                    row += `<td>${designation}</td>
                        <td>
                            <input type="number" class="form-control form-control-sm" value="${originalQuantity}" name="lines[${id}][quantity]" required step="0.001">
                        </td>
                        <td class="text-center">${originalQuantity} ${unit}</td></tr>`
                } else {
                    row += `<td colspan="3"><span class="ix-trade-line-title">${designation}</span></td></tr>`
                }

                formLinesContainer.append(row)
            })

            // Ajouter les sous-lignes SN
            populateCancelSerialNumberRows();
        } else {
            $('#cancelInvoiceModal').find($('table')).hide()
            $('#cancelInvoiceModal').find($('.alert')).show()
        }

        $('#cancelInvoiceModal').modal('show');
    });

    // Ajoute une sous-ligne sous chaque ligne d'article avec SN, affichant des chips
    // cliquables (cochées par défaut = retourné). Clique pour basculer sélection.
    // La sélection ne peut pas dépasser la quantité saisie sur la ligne.
    // Un kit a un groupe de chips par composant à numéros : au plus kits × quantité par kit.
    function populateCancelSerialNumberRows() {
        var snMap = {};
        try {
            snMap = JSON.parse($('#cancelInvoiceModal').attr('data-serial-numbers') || '{}');
        } catch (e) {
            snMap = {};
        }

        $('.cancel-line-row').each(function () {
            var $row = $(this);
            var lineId = $row.data('line-id');

            // Supprimer une éventuelle sous-ligne SN existante
            $row.next('.cancel-sn-row').remove();

            var entry = snMap[lineId];
            if (!entry) {
                return;
            }

            var $qtyInput = $row.find('input[name="lines[' + lineId + '][quantity]"]');
            var groups = entry.components
                ? entry.components.map(function (component) {
                    return { label: component.name, articleId: component.article_id, perKit: component.quantity, sns: component.serials };
                })
                : [{ label: null, articleId: null, perKit: null, sns: entry }];

            var html = '';
            groups.forEach(function (group) {
                if (!group.sns || group.sns.length === 0) return;

                var maxQty = group.perKit ? kitSerialCount($qtyInput.val(), group.perKit) : (parseInt($qtyInput.val()) || 0);
                var key = group.articleId ? group.articleId + '_' : '';

                if (group.label) {
                    html += '<div style="font-size: 12px; margin-top: 4px;">' + $('<div>').text(group.label).html() + '</div>';
                }
                html += '<div class="cancel-sn-chips-container" data-line-id="' + lineId + '"' + (group.perKit ? ' data-per-kit="' + group.perKit + '"' : '') + ' style="display: flex; flex-wrap: wrap; gap: 6px; padding: 6px 0;">';
                group.sns.forEach(function (sn, snIndex) {
                    // Ne pas pré-sélectionner au-delà de la quantité
                    var selected = snIndex < maxQty;
                    var chipStyle = selected
                        ? 'background: #e8f5e9; border: 1px solid #c8e6c9; color: #2e7d32;'
                        : 'background: #f5f5f5; border: 1px solid #e0e0e0; color: #9e9e9e; text-decoration: line-through; opacity: 0.6;';
                    var chipClass = selected ? 'cancel-sn-chip' : 'cancel-sn-chip cancel-sn-chip-excluded';
                    var hiddenDisabled = selected ? '' : 'disabled';
                    var name = 'lines[' + lineId + '][serial_numbers][' + key + snIndex + ']';
                    html += '<span class="' + chipClass + '" data-sn="' + sn + '" data-line-id="' + lineId + '" data-sn-index="' + snIndex + '" style="display: inline-flex; align-items: center; cursor: pointer; user-select: none; ' + chipStyle + ' border-radius: 16px; padding: 4px 12px; font-size: 12px; transition: all 0.15s;">';
                    html += '<i class="far fa-barcode" style="margin-right: 6px;"></i>' + sn;
                    html += '<input type="hidden" name="' + name + '[serial_number]" value="' + sn + '" ' + hiddenDisabled + '>';
                    if (group.articleId) {
                        html += '<input type="hidden" name="' + name + '[article_id]" value="' + group.articleId + '" ' + hiddenDisabled + '>';
                    }
                    html += '</span>';
                });
                html += '</div>';
                html += '<div class="cancel-sn-counter" data-line-id="' + lineId + '" style="font-size: 11px; margin-top: 4px;"></div>';
            });

            if (html === '') {
                return;
            }

            $row.after('<tr class="cancel-sn-row"><td></td><td colspan="3"><div style="font-size: 11px; color: #586069; margin-bottom: 2px;"><i class="far fa-barcode" style="margin-right: 4px;"></i>Numéros de série retournés : cliquez pour exclure un NS</div>' + html + '</td></tr>');
        });

        updateCancelSnCounters();

        // Toggle sélection au clic sur un chip
        $('.cancel-sn-chip').off('click').on('click', function () {
            var $chip = $(this);
            var $container = $chip.closest('.cancel-sn-chips-container');
            var $hidden = $chip.find('input[type="hidden"]');

            if ($chip.hasClass('cancel-sn-chip-excluded')) {
                // Réinclure : vérifier qu'on ne dépasse pas la quantité
                var maxQty = getCancelSnMax($container);

                if (getSelectedSnCount($container) >= maxQty) {
                    flashCancelSnWarning($container, 'Vous ne pouvez pas sélectionner plus de ' + maxQty + ' numéro(s) de série (quantité saisie).');
                    return;
                }

                $chip.removeClass('cancel-sn-chip-excluded');
                $chip.css({ 'background': '#e8f5e9', 'border-color': '#c8e6c9', 'color': '#2e7d32', 'text-decoration': 'none', 'opacity': '1' });
                $hidden.prop('disabled', false);
            } else {
                // Exclure
                $chip.addClass('cancel-sn-chip-excluded');
                $chip.css({ 'background': '#f5f5f5', 'border-color': '#e0e0e0', 'color': '#9e9e9e', 'text-decoration': 'line-through', 'opacity': '0.6' });
                $hidden.prop('disabled', true);
            }

            updateCancelSnCounters();
        });

        // Quand la quantité change sur une ligne avec SN, ajuster la sélection
        $('.cancel-line-row input[name$="[quantity]"]').off('input change').on('input change', function () {
            var lineId = $(this).closest('.cancel-line-row').data('line-id');

            $('.cancel-sn-chips-container[data-line-id="' + lineId + '"]').each(function () {
                var $container = $(this);
                var maxQty = getCancelSnMax($container);
                var selectedCount = 0;

                $container.find('.cancel-sn-chip').each(function () {
                    var $chip = $(this);
                    if (!$chip.hasClass('cancel-sn-chip-excluded')) {
                        selectedCount++;
                        if (selectedCount > maxQty) {
                            // Auto-exclure l'excédent
                            $chip.addClass('cancel-sn-chip-excluded');
                            $chip.css({ 'background': '#f5f5f5', 'border-color': '#e0e0e0', 'color': '#9e9e9e', 'text-decoration': 'line-through', 'opacity': '0.6' });
                            $chip.find('input[type="hidden"]').prop('disabled', true);
                        }
                    }
                });
            });

            updateCancelSnCounters();
        });
    }

    // Le maximum de SN d'un groupe : la quantité saisie, ou pour un composant de kit kits × quantité par kit
    function getCancelSnMax($container) {
        var lineId = $container.data('line-id');
        var quantity = $('.cancel-line-row[data-line-id="' + lineId + '"]').find('input[name$="[quantity]"]').val();
        var perKit = $container.data('per-kit');

        return perKit ? kitSerialCount(quantity, perKit) : (parseInt(quantity) || 0);
    }

    // Compte le nombre de SN sélectionnés (non exclus) d'un groupe
    function getSelectedSnCount($container) {
        return $container.find('.cancel-sn-chip').not('.cancel-sn-chip-excluded').length;
    }

    // Met à jour les compteurs "X / Y sélectionnés" sous chaque groupe de SN
    function updateCancelSnCounters() {
        $('.cancel-sn-chips-container').each(function () {
            var $container = $(this);
            var total = $container.find('.cancel-sn-chip').length;
            var selected = getSelectedSnCount($container);
            var maxQty = getCancelSnMax($container);

            var color = selected > maxQty ? '#d15240' : (selected < maxQty && selected < total ? '#fd7e14' : '#586069');
            $container.next('.cancel-sn-counter').html('<span style="color: ' + color + ';">' + selected + ' / ' + maxQty + ' sélectionné(s)</span>');
        });
    }

    // Affiche un avertissement temporaire sous le groupe de SN
    function flashCancelSnWarning($container, message) {
        var $counter = $container.next('.cancel-sn-counter');
        $counter.html('<span style="color: #d15240;"><i class="far fa-exclamation-triangle" style="margin-right: 4px;"></i>' + message + '</span>');
        clearTimeout($counter.data('timeout'));
        $counter.data('timeout', setTimeout(function () {
            updateCancelSnCounters();
        }, 3000));
    }

    // Quand le modal d'annulation est affiché après une erreur de validation,
    // les lignes sont rendues côté serveur (old('lines')) sans sous-lignes SN.
    // On les ajoute au show du modal.
    $('#cancelInvoiceModal').on('shown.bs.modal', function () {
        if ($('.cancel-line-row').length > 0 && $('.cancel-sn-row').length === 0) {
            populateCancelSerialNumberRows();
        }
    });

    $('.linked-button').on('click', function (e) {
        $('#' + $(this).data('target')).click();
    });

    $('#rated-clear').on('click', function (e) {
        $(this).css('display', 'none');
        $('#rated-input').val(0);

        $('#rated i.fas.fa-star').removeClass('fas fa-star');
        $('#rated i').addClass('far fa-star');
        e.preventDefault();
    });

    $('.ix-remove-picture-btn').on('click', function (e) {
        var url = $(this).data("url");
        var content = $(this).html();
        $(this).prop("disabled", true);
        $(this).html('<i class="far fa-circle-notch fa-spin"></i> Suppression en cours')

        fetch(url, {
            headers: getHeaders(),
            method: 'DELETE'
        }).then(function (response) {
            if (response.status == 200) {
                response.json().then(function (data) {
                    if (data) {
                        $('.ix-remove-picture-btn').html('<i class="far fa-check"></i> Action réalisée avec succès');
                        $('.ix-open-picture-btn').css('display', 'none');
                        $('.ix-remove-picture-btn').fadeOut(3000);
                        $('#target-remove-picture-preview').hide();
                        $('.ix-photo-picker').removeClass('has-photo');
                    }
                })
            } else {
                alertError(null);
                $('.ix-remove-picture-btn').html(content);
                $('.ix-remove-picture-btn').prop("disabled", false);
            }
        }).catch(function (error) {
            alertError(null);
            $('.ix-remove-picture-btn').html(content);
            $('.ix-remove-picture-btn').prop("disabled", false);
        });
        e.preventDefault();
    })



    // Formulaire de création de l'adresse à partir des sociétés
    var addressInput = document.getElementById('address_1') || document.getElementById('modal_address_address_1');
    if (addressInput != null) {
        var zipCodeInput = document.getElementById('zip_code') || document.getElementById('modal_address_zip_code');
        var cityInput = document.getElementById('city') || document.getElementById('modal_address_city');
        var countryInput = document.getElementById('country') || document.getElementById('modal_address_country');
        window.addEventListener('load', getGoogleLocation(addressInput, zipCodeInput, cityInput, countryInput));
    }


});


function calculateTotalRemaining() {
    const checkboxes = $('.check-all-container-lines').find($("input[type=\"checkbox\"]:checked"));
    var totalRemainingTotal = 0;
    if (checkboxes.length > 0) {
        checkboxes.each(function () {
            var remainingTotal = $(this).data('remaining-total');
            totalRemainingTotal += remainingTotal;
        })
    }

    return totalRemainingTotal;
}

function updateAcomptePreview() {
    var mode = $('#acompte_mode_hidden').val() || 'percent';
    var orderNumber = $('#acompte-preview').data('order-number') || '';

    var acompteHt = 0;
    var percent = 0;

    if (mode === 'amount') {
        var amount = parseFloat($('#acompte_amount').val()) || 0;
        if (amount <= 0) {
            $('#acompte-empty-message').show();
            $('#acompte-totals').hide();
            return;
        }
        var orderTotalTtc = parseFloat($('#acompte_order_total_ttc').val()) || 0;
        var orderTotalHt = parseFloat($('#input_invoice_total_ht').val()) || 0;
        percent = orderTotalTtc > 0 ? (amount / orderTotalTtc) * 100 : 0;
        acompteHt = (percent * orderTotalHt) / 100;
    } else {
        percent = parseFloat($('#percent').val()) || 0;
        if (!percent || percent <= 0) {
            $('#acompte-empty-message').show();
            $('#acompte-totals').hide();
            return;
        }
        var orderTotalHt2 = parseFloat($('#input_invoice_total_ht').val()) || 0;
        acompteHt = ((percent * orderTotalHt2) / 100);
    }

    $('#acompte-empty-message').hide();
    $('#acompte-totals').show();

    var totalVat = 0;

    $('.acompte-vat-row').each(function() {
        var rate = parseFloat($(this).data('rate')) || 0;
        var base = parseFloat($(this).data('base')) || 0;
        var vatAmount = ((base * percent) / 100) * (rate / 100);
        totalVat += vatAmount;
        $(this).find('td:last-child').text(formatCurrency(vatAmount.toFixed(2)));
    });

    var ecoAmount = 0;
    if ($('#input_order_eco_participation').length) {
        var orderEco = parseFloat($('#input_order_eco_participation').val()) || 0;
        ecoAmount = (orderEco * percent) / 100;
        $('#acompte-eco-amount').text(formatCurrency(ecoAmount.toFixed(2)));
    }

    $('#acompte-total-vat').text(formatCurrency(totalVat.toFixed(2)));

    var acompteTtc = acompteHt + ecoAmount + totalVat;
    $('#acompte-total-ht').text(formatCurrency(acompteHt.toFixed(2)));
    $('#acompte-total-ttc').text(formatCurrency(acompteTtc.toFixed(2)));
}

function updateProgressPreview() {
    if (!$('#progress-preview').length) {
        return;
    }

    var percent = parseFloat($('#global_percentage').val()) || 0;

    if (percent <= 0) {
        $('#progress-percent-display').text('0%');
        $('#progress-total-ht').text(formatCurrency('0.00'));
        $('#progress-total-vat').text(formatCurrency('0.00'));
        $('#progress-total-ttc').text(formatCurrency('0.00'));
        if ($('#progress-eco-amount').length) {
            $('#progress-eco-amount').text(formatCurrency('0.00'));
        }
        $('.progress-vat-row').each(function() {
            $(this).find('td:last-child').text(formatCurrency('0.00'));
        });
        $('#progress-acompte-deduction-row').hide();
        return;
    }

    $('#progress-percent-display').text(percent + '%');

    // Build line data map from checkboxes
    var lineData = {};
    var checkboxes = $('.check-all-container-lines').find($("input[type=\"checkbox\"]:checked"));
    checkboxes.each(function () {
        var lineId = $(this).val();
        lineData[lineId] = {
            vatRate: parseFloat($(this).data('vat-rate')) || 0,
            totalHt: parseFloat($(this).data('total-ht')) || 0,
            originalQuantity: parseFloat($(this).data('quantity')) || 0,
            remainingTotal: parseFloat($(this).data('remaining-total')) || 0,
            isEco: parseInt($(this).data('is-eco')) === 1
        };
    });

    // Calculate HT and VAT from percentage inputs when available
    var vatBasesByRate = {};
    var progressHt = 0;
    var hasPercentageInputs = $('.percentage-input').length > 0;

    if (hasPercentageInputs) {
        $('.percentage-input').each(function () {
            var lineId = $(this).data('line-id');
            var data = lineData[lineId];
            if (!data) return;

            var linePercent = parseFloat($(this).val()) || 0;
            var originalQty = parseFloat($(this).data('original-quantity')) || data.originalQuantity;
            var unitPrice = originalQty > 0 ? data.totalHt / originalQty : 0;
            var lineQty = originalQty * linePercent / 100;
            var lineHt = lineQty * unitPrice;

            if (!data.isEco) {
                progressHt += lineHt;
            }
            if (!vatBasesByRate[data.vatRate]) {
                vatBasesByRate[data.vatRate] = 0;
            }
            vatBasesByRate[data.vatRate] += lineHt;
        });
    } else {
        // Fallback: use checkbox remaining totals
        var selectedRemaining = calculateTotalRemaining();
        progressHt = (selectedRemaining * percent) / 100;
        checkboxes.each(function () {
            var vatRate = parseFloat($(this).data('vat-rate')) || 0;
            var remainingTotal = parseFloat($(this).data('remaining-total')) || 0;
            var isEco = parseInt($(this).data('is-eco')) === 1;
            if (!vatBasesByRate[vatRate]) {
                vatBasesByRate[vatRate] = 0;
            }
            vatBasesByRate[vatRate] += remainingTotal;
        });
    }

    // progressHt is the raw HT (before global discount) from selected lines
    var rawHt = progressHt;
    var orderDiscount = parseFloat($('#input_order_discount').val()) || 0;
    var discountAmount = rawHt * (orderDiscount / 100);
    progressHt = rawHt - discountAmount; // net after global discount

    // Update VAT bases to use net amounts (after global discount)
    Object.keys(vatBasesByRate).forEach(function(rate) {
        vatBasesByRate[rate] = vatBasesByRate[rate] * (1 - orderDiscount / 100);
    });

    // Discount display
    if (orderDiscount > 0 && $('#progress-raw-ht-row').length) {
        $('#progress-raw-ht-row').show();
        $('#progress-raw-ht').text(formatCurrency(rawHt.toFixed(2)));
        $('#progress-discount-row').show();
        $('#progress-discount-amount').text(formatCurrency((-discountAmount).toFixed(2)));
    } else {
        $('#progress-raw-ht-row').hide();
        $('#progress-discount-row').hide();
    }

    $('#progress-total-ht').text(formatCurrency(progressHt.toFixed(2)));

    // Calculate VAT per rate
    var totalVat = 0;
    $('.progress-vat-row').each(function() {
        var rate = parseFloat($(this).data('rate')) || 0;
        var base = vatBasesByRate[rate] || 0;
        var vatAmount = base * (rate / 100);
        totalVat += vatAmount;
        $(this).find('td:last-child').text(formatCurrency(vatAmount.toFixed(2)));
    });

    $('#progress-total-vat').text(formatCurrency(totalVat.toFixed(2)));

    // Eco-participation: calculated from eco lines directly
    var ecoAmount = 0;
    if ($('#progress-eco-amount').length) {
        if (hasPercentageInputs) {
            $('.percentage-input').each(function () {
                var lineId = $(this).data('line-id');
                var data = lineData[lineId];
                if (!data || !data.isEco) return;

                var linePercent = parseFloat($(this).val()) || 0;
                var originalQty = parseFloat($(this).data('original-quantity')) || data.originalQuantity;
                var unitPrice = originalQty > 0 ? data.totalHt / originalQty : 0;
                var lineQty = originalQty * linePercent / 100;
                ecoAmount += lineQty * unitPrice;
            });
        } else {
            checkboxes.each(function () {
                var isEco = parseInt($(this).data('is-eco')) === 1;
                if (!isEco) return;
                var remainingTotal = parseFloat($(this).data('remaining-total')) || 0;
                ecoAmount += remainingTotal * percent / 100;
            });
        }
        $('#progress-eco-amount').text(formatCurrency(ecoAmount.toFixed(2)));
    }

    var progressTtc = progressHt + ecoAmount + totalVat;

    // Acompte deduction
    var acompteDeductionHt = 0;
    if ($('#deduct_acompte').is(':checked') && $('#acompte_total_ht').length) {
        acompteDeductionHt = parseFloat($('#acompte_total_ht').val()) || 0;
        $('#progress-acompte-deduction-row').show();
        $('#progress-acompte-deduction-ht').text(formatCurrency((-acompteDeductionHt).toFixed(2)));
        progressTtc -= acompteDeductionHt;
    } else {
        $('#progress-acompte-deduction-row').hide();
    }

    $('#progress-total-ttc').text(formatCurrency(progressTtc.toFixed(2)));
}

function updateNormalPreview() {
    if (!$('#normal-preview').length) {
        return;
    }

    // Build a map of line_id -> {vatRate, remainingTotal, originalQuantity, totalHt, isEco} from checkboxes
    var lineData = {};
    var checkboxes = $('.check-all-container-lines').find($("input[type=\"checkbox\"]:checked"));
    checkboxes.each(function () {
        var lineId = $(this).val();
        var vatRate = parseFloat($(this).data('vat-rate')) || 0;
        var remainingTotal = parseFloat($(this).data('remaining-total')) || 0;
        var totalHt = parseFloat($(this).data('total-ht')) || 0;
        var originalQuantity = parseFloat($(this).data('quantity')) || 0;
        lineData[lineId] = {
            vatRate: vatRate,
            remainingTotal: remainingTotal,
            totalHt: totalHt,
            originalQuantity: originalQuantity,
            isEco: parseInt($(this).data('is-eco')) === 1
        };
    });

    // If form quantity inputs exist, recalculate based on entered quantities
    var vatBasesByRate = {};
    var totalHt = 0;
    var hasFormInputs = $('.quantity-input').length > 0;

    if (hasFormInputs) {
        $('.quantity-input').each(function () {
            var lineId = $(this).data('line-id');
            var data = lineData[lineId];
            if (!data) return;

            var qty = parseFloat($(this).val()) || 0;
            var originalQty = parseFloat($(this).data('original-quantity')) || data.originalQuantity;
            var unitPrice = originalQty > 0 ? data.totalHt / originalQty : 0;
            var lineHt = qty * unitPrice;

            if (!data.isEco) {
                totalHt += lineHt;
            }
            if (!vatBasesByRate[data.vatRate]) {
                vatBasesByRate[data.vatRate] = 0;
            }
            vatBasesByRate[data.vatRate] += lineHt;
        });
    } else {
        // Fallback: use checkbox remaining totals
        checkboxes.each(function () {
            var vatRate = parseFloat($(this).data('vat-rate')) || 0;
            var remainingTotal = parseFloat($(this).data('remaining-total')) || 0;
            var isEco = parseInt($(this).data('is-eco')) === 1;
            if (!vatBasesByRate[vatRate]) {
                vatBasesByRate[vatRate] = 0;
            }
            vatBasesByRate[vatRate] += remainingTotal;
            if (!isEco) {
                totalHt += remainingTotal;
            }
        });
    }

    // totalHt is the raw HT (before global discount) from selected lines
    var rawHt = totalHt;
    var orderDiscount = parseFloat($('#input_order_discount').val()) || 0;
    var discountAmount = rawHt * (orderDiscount / 100);
    totalHt = rawHt - discountAmount; // net after global discount

    // Update VAT bases to use net amounts (after global discount)
    Object.keys(vatBasesByRate).forEach(function(rate) {
        vatBasesByRate[rate] = vatBasesByRate[rate] * (1 - orderDiscount / 100);
    });

    // Discount display
    if (orderDiscount > 0 && $('#normal-raw-ht-row').length) {
        $('#normal-raw-ht-row').show();
        $('#normal-raw-ht').text(formatCurrency(rawHt.toFixed(2)));
        $('#normal-discount-row').show();
        $('#normal-discount-amount').text(formatCurrency((-discountAmount).toFixed(2)));
    } else {
        $('#normal-raw-ht-row').hide();
        $('#normal-discount-row').hide();
    }

    $('#normal-total-ht').text(formatCurrency(totalHt.toFixed(2)));

    // Calculate VAT per rate
    var totalVat = 0;
    $('.normal-vat-row').each(function() {
        var rate = parseFloat($(this).data('rate')) || 0;
        var base = vatBasesByRate[rate] || 0;
        var vatAmount = base * (rate / 100);
        totalVat += vatAmount;
        $(this).find('td:last-child').text(formatCurrency(vatAmount.toFixed(2)));
    });

    $('#normal-total-vat').text(formatCurrency(totalVat.toFixed(2)));

    // Eco-participation: calculated from eco lines directly
    var ecoAmount = 0;
    if ($('#normal-eco-row').length) {
        if (hasFormInputs) {
            $('.quantity-input').each(function () {
                var lineId = $(this).data('line-id');
                var data = lineData[lineId];
                if (!data || !data.isEco) return;

                var qty = parseFloat($(this).val()) || 0;
                var originalQty = parseFloat($(this).data('original-quantity')) || data.originalQuantity;
                var unitPrice = originalQty > 0 ? data.totalHt / originalQty : 0;
                ecoAmount += qty * unitPrice;
            });
        } else {
            checkboxes.each(function () {
                var isEco = parseInt($(this).data('is-eco')) === 1;
                if (!isEco) return;
                var remainingTotal = parseFloat($(this).data('remaining-total')) || 0;
                ecoAmount += remainingTotal;
            });
        }
        $('#normal-eco-amount').text(formatCurrency(ecoAmount.toFixed(2)));
    }

    var totalTtc = totalHt + ecoAmount + totalVat;

    // Acompte deduction
    if ($('#deduct_acompte').is(':checked') && $('#acompte_total_ttc').length) {
        var acompteDeductionTtc = parseFloat($('#acompte_total_ttc').val()) || 0;
        $('#normal-acompte-deduction-row').show();
        $('#normal-acompte-deduction-ttc').text(formatCurrency((-acompteDeductionTtc).toFixed(2)));
        totalTtc -= acompteDeductionTtc;
    } else {
        $('#normal-acompte-deduction-row').hide();
    }

    $('#normal-total-ttc').text(formatCurrency(totalTtc.toFixed(2)));
}

function updateTextTotalRemaining() {
    if($('#total-ht-block').length){
        var value = $('#percent').length ? $('#percent').val() : 100;
        var totalRemainingTotal = calculateTotalRemaining();
        var finalRenderValue = ((value * totalRemainingTotal) / 100).toFixed(2);
        $('#invoice_total_ht').text(formatCurrency(finalRenderValue));
    }
}

function disableButtonAndLoad(button) {
    button.data('original', button.html())
    button.html('<i class="far fa-circle-notch fa-spin"></i>');
    button.prop("disabled", true);
    button.addClass("disabled");
}

function resetButtonAfterLoad(button) {
    button.html(button.data('original'));
    button.prop("disabled", false);
    button.removeClass("disabled");
}


/**
 * Désactivation du bouton de soumission du formulaire
 * @param form
 */
function disableSubmitButton(form) {
    var submitCallAction = $(form).find(':submit');
    submitCallAction.html('<i class="far fa-circle-notch fa-spin"></i>');
    submitCallAction.prop("disabled", true);
    submitCallAction.addClass("disabled");
    $(form).addClass('submitted');
}

/**
 * Confirmation avant suppression
 *
 * https://github.com/sweetalert2/sweetalert2
 */

function confirmDelete(e) {
    e.preventDefault();
    let message = $(this).data('message');

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: message ? message : "Vous ne pourrez pas revenir en arrière",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#D15240',
        confirmButtonText: 'Oui, supprimer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            if ($(this).is('a')) {
                window.location.href = $(this).attr('href')
            } else {
                disableSubmitButton(this)
                this.submit()
            }
        }
    })
}

function confirmDeletePreventive(e) {
    e.preventDefault();
    let message = $(this).data('message');

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: message ? message : "Les OT associés ainsi que les rapports d'interventions seront également supprimés",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#D15240',
        confirmButtonText: 'Oui, supprimer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            if ($(this).is('a')) {
                window.location.href = $(this).attr('href')
            } else {
                disableSubmitButton(this)
                this.submit()
            }
        }
    })
}


function confirmAcceptCreateQuote(e) {
    if ($('#create_new_deal_true:checked').length > 0) {
        e.preventDefault();
        let message = $(this).data('message');
        let self = $(this);
        Swal.fire({
            title: 'Etes vous sûrs de vouloir créer une nouvelle affaire ?',
            text: message ? message : "Ce choix sera irréversible.",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Annuler',
            confirmButtonColor: '#D15240',
            confirmButtonText: 'Oui, créer',
            reverseButtons: true,
            heightAuto: false
        }).then((result) => {
            if (result.value) {
                if ($(self).is('a')) {
                    window.location.href = $(self).attr('href')
                } else {
                    disableSubmitButton(self)
                    self.submit()
                }
            }
        })
    }
}


function confirmCloseInspection(e) {
    e.preventDefault();

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: "En fermant cet ordre de travail, tous les rapports d'interventions associées passeront à l'état 'terminé'",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#D15240',
        confirmButtonText: 'Oui, fermer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            if ($(this).is('a')) {
                window.location.href = $(this).attr('href')
            } else {
                disableSubmitButton(this)
                this.submit()
            }
        }
    })
}

/**
 * Confirmation avant duplication
 *
 */

function confirmDuplicate(e) {
    e.preventDefault();

    var form = $(this);

    /**
     * Option « Dupliquer également les documents ».
     *
     * Elle n'apparaît que sur les écrans qui déclarent data-documents-count,
     * c'est-à-dire aujourd'hui l'étude et le devis. Les autres écrans portant
     * .duplicate-form (formulaires, articles, dépenses, missions, groupes de
     * prestations, rôles) n'ont pas cet attribut et conservent donc la modale
     * à l'identique.
     *
     * Le compteur ne porte que sur les documents PROPRES de l'élément : ceux
     * qu'il se contente d'afficher parce qu'ils appartiennent à un élément lié
     * ne sont ni comptés ni copiés.
     *
     * Option « Dupliquer les dilutions de frais généraux » : uniquement sur
     * l'étude, quand data-overhead-dilutions-count indique au moins une
     * dilution enregistrée. Décochée à chaque ouverture : la case est recréée
     * avec la modale.
     */
    var documentsCount = parseInt(form.data('documents-count') || 0, 10);
    var overheadDilutionsCount = parseInt(form.data('overhead-dilutions-count') || 0, 10);
    var elementLabel = form.data('element-label') || 'cet élément';
    var message = "Vous devrez disposer des permissions de modifications afin de modifier la copie de cet élément";
    var options = {
        title: 'Êtes-vous sûr ?',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Dupliquer',
        reverseButtons: true,
        heightAuto: false
    };

    var choices = '';

    if (documentsCount > 0) {
        var documentsLabel = documentsCount > 1
            ? 'les ' + documentsCount + ' documents'
            : 'le document';

        choices += '<div class="custom-control custom-checkbox">'
            +         '<input type="checkbox" class="custom-control-input" id="duplicateDocumentsCheck">'
            +         '<label class="custom-control-label" for="duplicateDocumentsCheck">Dupliquer également ' + documentsLabel + '</label>'
            +     '</div>'
            +     '<small class="ix-text-secondary d-block mt-1">Les documents propres à ' + elementLabel + ' seront également copiés dans la nouvelle version.</small>';
    }

    if (overheadDilutionsCount > 0) {
        choices += '<div class="custom-control custom-checkbox' + (choices ? ' mt-3' : '') + '">'
            +         '<input type="checkbox" class="custom-control-input" id="duplicateOverheadDilutionsCheck">'
            +         '<label class="custom-control-label" for="duplicateOverheadDilutionsCheck">Dupliquer également les dépenses et leur répartition</label>'
            +     '</div>'
            +     '<small class="ix-text-secondary d-block mt-1">Les dépenses réparties propres à ' + elementLabel + ' seront également copiées dans la nouvelle version.</small>';
    }

    if (choices) {
        options.html = message + '<div class="text-left mt-4">' + choices + '</div>';

        // Lecture avant la fermeture de la modale : son DOM n'existe plus
        // dans le then().
        options.preConfirm = function () {
            var documentsCheckbox = document.getElementById('duplicateDocumentsCheck');
            var overheadDilutionsCheckbox = document.getElementById('duplicateOverheadDilutionsCheck');

            form.find('input[name="duplicate_documents"]').val(documentsCheckbox && documentsCheckbox.checked ? 1 : 0);
            form.find('input[name="duplicate_overhead_dilutions"]').val(overheadDilutionsCheckbox && overheadDilutionsCheckbox.checked ? 1 : 0);

            return true;
        };
    } else {
        options.text = message;
    }

    Swal.fire(options).then((result) => {
        // isConfirmed et non value : avec une case décochée, preConfirm peut
        // renvoyer une valeur falsy et le formulaire ne serait jamais soumis.
        if (result.isConfirmed) {
            if (form.is('a')) {
                window.location.href = form.attr('href')
            } else {
                disableSubmitButton(this)
                this.submit()
            }
        }
    })
}

/**
 * Confirmation avant action
 */

function confirmForm(e) {
    e.preventDefault();
    let message = $(this).data('message');
    let actionText = $(this).data('action-text');

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: message ? message : "Vous ne pourrez pas revenir en arrière",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: actionText ? actionText : 'Confirmer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            disableSubmitButton(this)
            this.submit()
        }
    })
}

/**
 * Confirmation avant action
 */

function confirmFormDealUnClosed(e) {
    e.preventDefault();
    let message = $(this).data('message');
    let actionText = $(this).data('action-text');

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: actionText ? actionText : 'Confirmer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            disableSubmitButton(this)
            this.submit()
        }
    })
}


/**
 * Alert erreur
 */
function alertError(message) {
    Swal.fire({
        title: 'Erreur',
        text: message ? message : "Une erreur s'est produite. Veuillez contacter votre administrateur",
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'Ok',
        reverseButtons: true,
        heightAuto: false
    })
}

/**
 * Format monétaire
 */
function formatCurrency(val) {
    var amount = parseFloat(val);
    amount = amount.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
    amount += "€";

    return amount
}

/**
 * Récupération des headers commun
 */
function getHeaders() {
    return {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        'Accept': 'application/json',
        'Authorization': `Bearer ${API_TOKEN}`
    }
}

/**
 * Scroll au bloc
 */
function scrollToAnchor(id) {
    var el = $("#" + id);
    if (el) {
        $('html,body').animate({ scrollTop: el.offset().top }, 'slow');
    }
}

function getGoogleLocation(mainInput, zipCodeInput = null, cityInput = null, countryInput = null) {

    var autocomplete = new google.maps.places.Autocomplete(mainInput, {
        componentRestrictions: { 'country': ['FR'] },
        fields: ['place_id', 'name', 'address_components']
    });


    autocomplete.addListener('place_changed', function () {
        let zipCode, city, country = null;
        var place = autocomplete.getPlace();
        mainInput.value = place.name;

        place?.address_components?.forEach(entry => {
            if (entry.types?.[0] == "postal_code") {
                zipCode = entry.long_name;
            }
            if (entry.types?.[0] == "locality") {
                city = entry.long_name;
            }
            if (entry.types?.[0] == "country") {
                country = entry.short_name;
            }

        })

        if (zipCodeInput != null) {
            zipCodeInput.value = zipCode != null ? zipCode : '';
        }
        if (cityInput != null) {
            cityInput.value = city != null ? city : '';
        }
        if (countryInput != null) {
            countryInput.value = country != null ? country : '';
        }
    });

}

/* Vue JS component */
Vue.mixin({
    methods: {
        getHttpJsonRequestHeaders: function (isFormData = false) {
            var headers = getHeaders();

            if (isFormData) {
                delete headers['Content-Type']
            }

            const data = {
                credentials: 'same-origin',
                headers: headers
            }

            return data
        },
        currency: function (val) {
            return formatCurrency(val)
        },
        onGlobalEmplacementChange: function (emplacement) {
            var btn = document.getElementById('applyGlobalEmplacementBtn');
            if (btn) {
                if (emplacement) {
                    btn.removeAttribute('disabled');
                } else {
                    btn.setAttribute('disabled', 'disabled');
                }
            }
        },
        /**
         * Rendu d'une suggestion d'étude / prestation : ligne article (PAMP ou fournisseur
         * favori) puis une ligne indentée par tarif fournisseur.
         */
        studySuggestionItemHtml: function (item) {
            if (item.is_child) {
                // Le coût d'un kit vient de sa composition, pas des achats.
                var label = item.provider
                    ? `Vendu par ${item.provider} ${item.is_favorite ? '<span class="ix-text-yellow"><i class="far fa-star"></i></span>' : ''} ${item.provider_reference ? '- ' + item.provider_reference : ''} ${item.indications ? '- ' + item.indications : ''}`
                    : (item.is_kit ? item.price_label : `${item.price_label} <span class="text-muted">(moyenne des achats sur 12 mois)</span>`)

                return `<div class="d-flex align-items-center ix-text-small ix-suggestion-small">
                            <span><i class="far fa-level-up fa-rotate-90"></i> ${label}</span>
                            <span class="ml-auto">${item.formatted_amount}</span>
                        </div>`
            }

            // Un kit se reconnaît dès la suggestion, comme sur un devis.
            var badge = item.is_kit
                ? '<span class="badge badge-primary">Article composé</span>'
                : `<span class="badge badge-secondary">${item.category}</span>`;
            var html = `<div class="d-flex align-items-center">
                            ${badge}
                            <span class="ml-2">${item.autocomplete_label}</span>`

            if (item.is_title) {
                html += `</div>`
            } else {
                html += `<span class="ml-auto">${item.price_label ? '<span class="ix-text-small text-muted mr-2">' + item.price_label + '</span>' : ''}${item.formatted_amount}</span>
                        </div>`
            }

            return html
        },
        formatHours: function (decimalHours) {
            if (decimalHours === null || decimalHours === undefined || decimalHours === '') {
                return '-';
            }
            const h = Math.floor(decimalHours);
            const m = Math.round((decimalHours - h) * 60);
            if (m === 0) return `${h}h`;
            return `${h}:${m.toString().padStart(2, '0')}`;
        },
        nl2br(str, is_xhtml) {
            var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },
        truncate(str, n) {
            return (str.length > n) ? str.substr(0, n - 1
            ) + '&hellip;' : str;
        },
        roundCurrency(num, places) {
            return +(Math.round(num + "e+" + places) + "e-" + places);
        },
        moment: function (date = null) {
            return date ? moment(date) : moment();
        },
        momentFromFormat: function (date, format) {
            return moment(date, format);
        },
        searchInUrl: function (param) {
            var tmp = [];
            var result = null;

            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] == param) {
                        result = tmp.length > 1 ? tmp[1] : true
                    }
                });

            return result;
        },
        __: function (key, replace = {}) {
            // Fonction de traduction Laravel pour Vue
            let translation = key.split('.').reduce((t, i) => t[i] || null, window.translations || {});
            
            if (!translation) {
                return key;
            }

            // Remplacer les placeholders :key par les valeurs
            Object.keys(replace).forEach(function (key) {
                translation = translation.replace(':' + key, replace[key]);
            });

            return translation;
        }
    }
})

Vue.filter('formatDate', function (value, format) {
    if (value) {
        return moment(String(value)).format(format ? format : 'DD MMM YYYY - HH:mm')
    }
});

Vue.filter('formatFileSize', function (value, dp = 0) {
    if (value) {
        //const thresh = si ? 1000 : 1024;
        const thresh = 1000;

        if (Math.abs(value) < thresh) {
            return value + ' B';
        }

        const units = ['ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'];
        let u = -1;
        const r = 10 ** dp;

        do {
            value /= thresh;
            ++u;
        } while (Math.round(Math.abs(value) * r) / r >= thresh && u < units.length - 1);


        return value.toFixed(dp) + ' ' + units[u];
    }
})

var vm = new Vue({
    el: '#app',
    data: {
        store: {
            forms: [],
            activeForm: [],
            activeModalFormBuilder: false,
            element: null,
            indexModal: null,
            formIsValid: true,
            formMode: '',
        },
    },
    components: {
        GenericMultiSelect,
        QuoteAcceptance,
        UsersStatistics,
        TradeEvolution,
        ClientBalance,
        DebtorsRank,
        FiltersSummary,
        Comments,
        LineTableForm,
        LineForm,
        DiscountGridForm,
        ShippingGridForm,
        VueTypeaheadBootstrap,
        Sendings,
        BonusSelector,
        ExpenseReportLineTableForm,
        ExpenseReportLineForm,
        Signatures,
        SignaturesReceptions,
        DocumentsManagerModal,
        DocumentsManager,
        BillPaymentOrderSelector,
        AbsencesTable,
        AbsencesTableModal,
        ArticleProviderTableForm,
        ArticleProviderForm,
        ArticleKitComponentsTableForm,
        ArticleKitComponentForm,
        ArticleKitPricingSummary,
        ArticlePriceRuleForm,
        CompanyPriceRuleModal,
        ArticleAttributeForm,
        PurchaseTableForm,
        PurchaseForm,
        ExpenseBillSelector,
        Elements,
        DisplayFormBuilder,
        RenderFormBuilder,
        UserSelector,
        ArticleSelector,
        ArticleDealsSummary,
        ArticleTradeStatsSummary,
        StockMovementTotals,
        ReceptionsValuationSummary,
        CheckingForm,
        InitScanCheckingForm,
        ProviderBalance,
        CheckingsTable,
        PredictionTableForm,
        PredictionForm,
        DeliveryLineTableForm,
        DeliveryLineForm,
        IndicatorsArray,
        DealProgress,
        ContractsStatistics,
        VatsArray,
        CompanySelector,
        CompanyPennylaneSync,
        InvoicePennylaneSync,
        CreditNotePennylaneSync,
        InvoiceValidationModal,
        AccountingAccountsAffectation,
        TasksTable,
        SubtasksManager,
        QuickNote,
        UserNotification,
        PhoneNumber,
        PriceForm,
        BillTotalsForm,
        OperationTableForm,
        OperationForm,
        DealLotOperation,
        SchedulesKanban,
        SchedulesSingle,
        SpendingEvolution,
        PrecheckingsTable,
        PrecheckingsForm,
        Note,
        CustomEditor,
        BankEvolution,
        PaymentComponent,
        PayableLine,
        ActivityPies,
        Counter,
        MapComponent,
        GeolocationPicker,
        TriggerComponent,
        PlanningTable,
        FormPlanningComponent,
        SyncOperation,
        CheckingMaintenanceForm,
        CreateInspectionComponent,
        PlanningTableModal,
        DealLotProgress,
        EditPredictionTable,
        SendingModalComponent,
        GroupOrders,
        InjectStudy,
        QuoteVersioning,
        AcceptQuoteVersionning,
        ServiceListTableForm,
        ServiceListForm,
        TradeStatistics,
        ChronoComponent,
        BillCreditSupplierForm,
        BillInboxSidebar,
        AccountingAccountGeneration,
        DiscountTrade,
        BookingLotArticleForm,
        BookingLotArticleLine,
        BookingArticleLine,
        BookingModal,
        ArticleProgressStock,
        BookingArticleTable,
        ArticleEcoTaxForm,
        EmplacementSelector,
        EmplacementTreeSelector,
        ArticleFamilySelector,
        EmplacementTreeManager,
        ArticleFamilyTreeManager,
        EmplacementArticlesManager,
        ArticleEmplacementsManager,
        ArticleFamilyArticlesManager,
        TreeMultiSelector,
        AutoFormSaveComponent,
        EquipmentStationTable,
        PrecheckingsInterventionForm,
        PrecheckingsInterventionTable,
        GroupDeliveries,
        EmplacementCascadingFilter,
        ArticleSerialNumberForm,
        ArticleSerialNumberHistoryModal,
        ArticleSerialNumberComponent
    },
});


global.vm = vm;

window.openSnHistoryModal = function(serialNumber) {
    if (vm.$refs.snHistoryModal) {
        vm.$refs.snHistoryModal.open(serialNumber);
    }
};

window.applyGlobalEmplacement = function() {
    var selectors = [];
    function findEmplacementSelectors(root) {
        if (root.$options.name === 'emplacement-tree-selector') {
            selectors.push(root);
        }
        root.$children.forEach(function(child) {
            findEmplacementSelectors(child);
        });
    }
    findEmplacementSelectors(vm);

    var globalSelector = selectors.find(function(s) {
        return s.inputName === 'global_emplacement_id';
    });

    if (!globalSelector || !globalSelector.selectedEmplacement) {
        return;
    }

    var globalEmplacement = globalSelector.selectedEmplacement;

    selectors.forEach(function(s) {
        if (s.inputName !== 'global_emplacement_id' && s.$el.classList.contains('js-reception-line-emplacement')) {
            s.selectEmplacement(globalEmplacement);
        }
    });
};

window.printQRCode = function (base64Image, docName) {
    var win = window.open('', '_blank');
    win.document.write('<html><head><title>Imprimer QR Code - ' + docName + '</title>');
    win.document.write('<style>');
    win.document.write('body { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; margin: 0; font-family: "Helvetica Neue", Arial, sans-serif; text-align: center; background: #f8fafc; color: #1e293b; }');
    win.document.write('.container { border: 2px solid #e2e8f0; padding: 40px; border-radius: 16px; background: white; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05); max-width: 400px; }');
    win.document.write('img { width: 250px; height: 250px; margin-bottom: 25px; display: inline-block; }');
    win.document.write('h2 { margin: 0 0 8px 0; color: #0f172a; font-size: 22px; font-weight: 700; word-break: break-word; }');
    win.document.write('p { margin: 0; color: #64748b; font-size: 14px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px; }');
    win.document.write('@media print { body { background: white; height: auto; } .container { border: none; box-shadow: none; padding: 0; max-width: 100%; margin-top: 10%; } }');
    win.document.write('</style></head><body>');
    win.document.write('<div class="container">');
    win.document.write('<h2>' + docName + '</h2>');
    win.document.write('<img src="' + base64Image + '" />');
    win.document.write('<p>Scanner pour ouvrir le document</p>');
    win.document.write('</div>');
    win.document.write('<script>window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 500); };<\/script>');
    win.document.write('</body></html>');
    win.document.close();
}

$(document).ready(function() {
    // Swal confirm for elements with data-swal-confirm
    $(document).on('click', '[data-swal-confirm]', function(e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var message = $(this).data('swal-confirm');
        Swal.fire({
            title: 'Êtes-vous sûr ?',
            text: message,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Confirmer',
            cancelButtonText: 'Annuler',
            confirmButtonColor: '#22c55e',
            reverseButtons: true,
            heightAuto: false
        }).then(function(result) {
            if (result.isConfirmed) {
                form.submit();
            }
        });
    });

    if ($('#name').length && $('#code').length && window.location.pathname.includes('/emplacements/create')) {
        let emplacements = [];
        
        // Charger l'arbre pour compter les enfants
        fetch('/api/emplacements/tree')
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    emplacements = data.emplacements;
                }
            });
            
        function generateCode() {
            const name = $('#name').val().trim();
            if (!name) {
                $('#code').val('');
                return;
            }
            
            // Si l'utilisateur a déjà modifié manuellement le code, on ne l'écrase pas
            if ($('#code').data('manually-edited')) return;
            
            let prefix = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").substring(0, 3).toUpperCase();
            prefix = prefix.replace(/[^A-Z]/g, '');
            if (prefix.length < 3) {
                prefix = (prefix + 'EMP').substring(0, 3);
            }
            
            const parentId = parseInt($('input[name="parent_id"]').val()) || null;
            const count = emplacements.filter(e => e.parent_id == parentId).length;
            
            $('#code').val(`${prefix}-${count + 1}`);
        }
        
        $('#name').on('input', generateCode);
        
        // Détecter les changements de parent_id (déclenchés par le sélecteur Vue)
        $(document).on('change', 'input[name="parent_id"]', generateCode);
        
        // Détecter si l'utilisateur modifie manuellement le code
        $('#code').on('input', function() {
            if ($(this).val().trim() !== '') {
                $(this).data('manually-edited', true);
            } else {
                $(this).data('manually-edited', false);
            }
        });
    }

    /**
     * Gestion des sections conditionnelles du formulaire de création d'inventaire
     * Affiche uniquement la section correspondant au type d'inventaire sélectionné.
     */
    function initInventoryTypeToggle() {
        var $sections = {
            article:     { el: $('#section-article'),     label: 'des articles à inventorier' },
            family:      { el: $('#section-family'),      label: 'des familles à inventorier' },
            emplacement: { el: $('#section-emplacement'), label: 'des zones de stockage à inventorier' }
        };
        var $typeLabel = $('#typeLabel');

        if (!$('input[name="type"]').length) return;

        function updateSections() {
            var selectedType = $('input[name="type"]:checked').val();
            if (!selectedType) return;
            $.each($sections, function(key, section) {
                if (section.el.length) {
                    section.el.toggle(key === selectedType);
                }
            });
            if ($typeLabel.length && $sections[selectedType]) {
                $typeLabel.text($sections[selectedType].label);
            }
        }

        $('input[name="type"]').on('change', updateSections);
        updateSections();
    }

    initInventoryTypeToggle();

    /**
     * Affiche/masque le champ "Zone de stockage" selon la quantité saisie
     * dans les formulaires de création et d'édition d'articles.
     */
    function initArticleEmplacementToggle($root, prefix) {
        var $stockInput = $root.find('#' + prefix + 'stock');
        var $emplacementField = $root.find('#' + prefix + 'emplacement-field');
        if (!$stockInput.length || !$emplacementField.length) return;

        function toggleEmplacement() {
            var stock = parseFloat($stockInput.val()) || 0;
            var show = stock !== 0;
            $emplacementField.toggle(show);

            if (show) {
                var $hidden = $emplacementField.find('input[name="emplacement_id"]');
                if (!$hidden.val()) {
                    var el = $emplacementField.find('.emplacement-tree-selector')[0];
                    if (el) {
                        el.dispatchEvent(new CustomEvent('emplacement:autoselect'));
                    }
                }
            }
        }

        $stockInput.on('input change', toggleEmplacement);
        toggleEmplacement();
    }

    initArticleEmplacementToggle($(document), '');

    /**
     * Affiche/masque la section "Numéros de série" selon l'état
     * du bouton radio "has_serial_numbers".
     */
    function initArticleSerialNumbersToggle($root, prefix) {
        var $radioTrue = $root.find('#' + prefix + 'has_serial_numbers_true');
        var $section = $root.find('#' + prefix + 'serial-numbers-section');
        if (!$radioTrue.length || !$section.length) return;

        function toggleSerialNumbers() {
            $section.toggle($radioTrue.is(':checked'));
        }

        $root.find('input[name="has_serial_numbers"]').on('change', toggleSerialNumbers);
        toggleSerialNumbers();
    }

    initArticleSerialNumbersToggle($(document), '');

    /**
     * Création d'un article : « Article composé » masque ce qu'un kit ne porte pas (stock,
     * numéros de série, fournisseurs, éco-participation) et affiche sa composition, vers
     * laquelle la page défile si elle est hors de l'écran. Le serveur impose de toute façon ces valeurs.
     */
    function initArticleKitToggle($root, scrollable) {
        var $radios = $root.find('input[type="radio"][name="is_kit"]');
        var $radioKit = $radios.filter('[value="1"]');
        if (!$radioKit.length) return;

        function toggleKit(scroll) {
            var isKit = $radioKit.is(':checked');
            $root.find('.js-simple-article-only').toggle(!isKit);
            $root.find('.js-kit-only').toggle(isKit);
            $radios.each(function () {
                $(this).closest('.ix-choice-card').toggleClass('is-selected', this.checked);
            });

            if (!scrollable) return;

            var top = $root.find('.js-kit-only').offset().top;
            if (isKit && scroll && top > $(window).scrollTop() + $(window).height() - 150) {
                $('html, body').animate({ scrollTop: top - 80 }, 300);
            }
        }

        $radios.on('change', function () { toggleKit(true); });
        toggleKit(false);
    }

    initArticleKitToggle($(document), true);

    /**
     * Zone de choix d'une photo : aperçu de l'image choisie avant l'enregistrement.
     */
    function initPhotoPicker($root) {
        $root.find('.ix-photo-picker input[type="file"]').on('change', function () {
            var $picker = $(this).closest('.ix-photo-picker');
            var file = this.files && this.files[0];
            if (!file) return;

            var reader = new FileReader();
            reader.onload = function (e) {
                $picker.find('img').attr('src', e.target.result).show();
                $picker.addClass('has-photo');
            };
            reader.readAsDataURL(file);
        });
    }

    initPhotoPicker($(document));

    /** Formulaire de création d'article injecté après le chargement (modale depuis une ligne). */
    window.initArticleForm = function (root) {
        var $root = $(root);
        initArticleKitToggle($root, false);
        initArticleEmplacementToggle($root, 'article_modal_');
        initArticleSerialNumbersToggle($root, 'article_modal_');
        initPhotoPicker($root);
        $root.find('.tag-autocomplete').each(function () { window.createInputTag(this); });
        $root.find('[data-toggle="tooltip"]').tooltip();
    };

    /**
     * Ventilation des quantités par zone de stockage dans les réceptions fournisseurs.
     * UX : formulaire de saisie (SN+Zone ou Qté+Zone) + récap avec suppression.
     * - Articles avec has_serial_numbers : saisie unitaire de SN + zone, unicité contrôlée, max = quantité réceptionnée
     * - Articles sans has_serial_numbers : saisie de quantité + zone, somme ≤ quantité réceptionnée
     */
    function initReceptionVentilation() {
        if ($('.vent-row').length === 0) return;

        var __globalSnRegistry = {};

        document.querySelectorAll('form.confirm-form, form').forEach(function(formEl) {
            if (!formEl.querySelector('.vent-row')) return;
            formEl.addEventListener('submit', function(e) {
                var incomplete = [];
                document.querySelectorAll('.vent-row').forEach(function(rowEl) {
                    var $row = $(rowEl);
                    var getStatus = $row.data('vent-get-status');
                    if (!getStatus) return;
                    var status = getStatus();
                    if (!status.complete) {
                        var label = $row.prev('tr').find('td').first().text().trim() || 'Article';
                        if (status.hasSn) {
                            incomplete.push(label + ' : ' + status.current + '/' + status.max + ' numéro(s) de série saisi(s)');
                        } else {
                            incomplete.push(label + ' : ' + status.current + '/' + status.max + ' quantité ventilée');
                        }
                    }
                });
                if (incomplete.length > 0) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    Swal.fire({
                        title: 'Ventilation incomplète',
                        text: 'Veuillez ventiler la totalité des articles avant d\'enregistrer.',
                        icon: 'error',
                        confirmButtonText: 'Compris',
                        confirmButtonColor: '#22c55e'
                    });
                }
            }, true);
        });

        var __emplacementsData = null;
        var __emplacementsPromise = fetch('/api/emplacements/tree', {
            method: 'GET',
            headers: getHeaders()
        }).then(function(r) { return r.json(); }).then(function(data) {
            if (data.success) {
                __emplacementsData = data.emplacements;
            }
            return __emplacementsData;
        });

        function escapeHtml(str) {
            return String(str == null ? '' : str)
                .replace(/&/g, '&amp;').replace(/</g, '&lt;')
                .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        }

        function getEmplacementMap() {
            var map = {};
            (__emplacementsData || []).forEach(function(e) { map[e.id] = e; });
            return map;
        }

        function getEmplacementName(empId) {
            var map = getEmplacementMap();
            var emp = map[empId];
            if (!emp) return '—';
            return emp.name + (emp.code ? ' (' + emp.code + ')' : '');
        }

        var __ventEtsCounter = 0;

        function buildEmplacementWidget(selectedId) {
            var widgetId = 'vent-ets-' + (++__ventEtsCounter);
            var emps = __emplacementsData || [];
            var map = {};
            emps.forEach(function(e) { map[e.id] = Object.assign({}, e, { children: [] }); });
            var roots = [];
            emps.forEach(function(e) {
                var node = map[e.id];
                if (node.parent_id && map[node.parent_id]) {
                    map[node.parent_id].children.push(node);
                } else {
                    roots.push(node);
                }
            });

            var html = '<div class="vent-ets" id="' + widgetId + '">';
            html += '<input type="hidden" class="vent-saisie-emp" value="' + (selectedId || '') + '">';
            html += '<div class="vent-ets-field" tabindex="0">';
            html += '<span class="vent-ets-field-value"></span>';
            html += '<div class="vent-ets-field-actions">';
            html += '<button type="button" class="vent-ets-clear-btn" style="display:none;"><i class="fal fa-times"></i></button>';
            html += '<i class="far fa-chevron-down vent-ets-chevron"></i>';
            html += '</div></div>';
            html += '<div class="vent-ets-dropdown" style="display:none;">';
            html += '<div class="vent-ets-search">';
            html += '<i class="far fa-search vent-ets-search-icon"></i>';
            html += '<input type="text" class="vent-ets-search-input" placeholder="Rechercher par nom ou code...">';
            html += '</div>';
            html += '<div class="vent-ets-tree-list"></div>';
            html += '</div></div>';

            return html;
        }

        function initEmplacementWidget($widget) {
            var emps = __emplacementsData || [];
            var map = {};
            emps.forEach(function(e) { map[e.id] = Object.assign({}, e, { children: [] }); });
            var roots = [];
            emps.forEach(function(e) {
                var node = map[e.id];
                if (node.parent_id && map[node.parent_id]) {
                    map[node.parent_id].children.push(node);
                } else {
                    roots.push(node);
                }
            });

            var expandedNodes = {};
            var $field = $widget.find('.vent-ets-field');
            var $dropdown = $widget.find('.vent-ets-dropdown');
            var $treeList = $widget.find('.vent-ets-tree-list');
            var $search = $widget.find('.vent-ets-search-input');
            var $hidden = $widget.find('.vent-saisie-emp');
            var $clearBtn = $widget.find('.vent-ets-clear-btn');
            var $valueSpan = $widget.find('.vent-ets-field-value');

            function getSelectedId() { return $hidden.val(); }

            function getSelectedName() {
                var id = getSelectedId();
                if (!id) return null;
                var emp = map[id];
                if (!emp) return null;
                return emp;
            }

            function renderField() {
                var emp = getSelectedName();
                if (emp) {
                    var fullPath = emp.name;
                    var parent = emp.parent_id ? map[emp.parent_id] : null;
                    while (parent) {
                        fullPath = parent.name + ' › ' + fullPath;
                        parent = parent.parent_id ? map[parent.parent_id] : null;
                    }
                    $valueSpan.html('<i class="far fa-map-marker-alt text-primary mr-1"></i><span class="vent-ets-field-text">' + escapeHtml(fullPath) + '</span>' + (emp.code ? '<span class="vent-ets-field-code">' + escapeHtml(emp.code) + '</span>' : ''));
                    $clearBtn.show();
                } else {
                    $valueSpan.html('<span class="vent-ets-field-placeholder">Sélectionner une zone...</span>');
                    $clearBtn.hide();
                }
            }

            function renderTree() {
                var query = $search.val().toLowerCase().trim();
                var html = '';

                if (query) {
                    var matched = {};
                    emps.forEach(function(e) {
                        if (e.name.toLowerCase().indexOf(query) !== -1 || (e.code && e.code.toLowerCase().indexOf(query) !== -1)) {
                            matched[e.id] = true;
                            var pid = e.parent_id;
                            while (pid && map[pid]) { matched[pid] = true; pid = map[pid].parent_id; }
                        }
                    });
                    var flatList = [];
                    function collectFlat(node, depth) {
                        if (!matched[node.id]) return;
                        flatList.push({ node: node, depth: depth });
                        if (node.children) node.children.forEach(function(c) { collectFlat(c, depth + 1); });
                    }
                    roots.forEach(function(r) { collectFlat(r, 0); });
                    if (flatList.length === 0) {
                        $treeList.html('<div class="vent-ets-empty"><i class="far fa-map-marker-slash"></i><span>Aucune zone trouvée.</span></div>');
                        return;
                    }
                    flatList.forEach(function(item) {
                        html += renderNode(item.node, item.depth, true);
                    });
                } else {
                    if (roots.length === 0) {
                        $treeList.html('<div class="vent-ets-empty"><i class="far fa-map-marker-slash"></i><span>Aucune zone disponible.</span></div>');
                        return;
                    }
                    roots.forEach(function(r) { html += renderNodeRecursive(r, 0); });
                }
                $treeList.html(html);
            }

            function renderNodeRecursive(node, depth) {
                var html = renderNode(node, depth, expandedNodes[node.id]);
                if (expandedNodes[node.id] && node.children) {
                    node.children.forEach(function(c) { html += renderNodeRecursive(c, depth + 1); });
                }
                return html;
            }

            function renderNode(node, depth, expanded) {
                var sel = (parseInt(getSelectedId()) === parseInt(node.id)) ? ' selected' : '';
                var hasChildren = node.children && node.children.length > 0;
                var iconClass = depth === 0 ? 'far fa-warehouse' : (depth === 1 ? 'far fa-folder' : 'far fa-map-marker-alt');
                var html = '<div class="vent-ets-node' + sel + '" data-emp-id="' + node.id + '">';
                for (var d = 0; d < depth; d++) html += '<span class="vent-ets-indent"></span>';
                if (hasChildren) {
                    html += '<span class="vent-ets-toggle" data-toggle-id="' + node.id + '"><i class="far fa-chevron-right' + (expanded ? ' expanded' : '') + '"></i></span>';
                } else {
                    html += '<span class="vent-ets-toggle-placeholder"></span>';
                }
                html += '<span class="vent-ets-node-icon ets-depth-' + Math.min(depth, 3) + '"><i class="' + iconClass + '"></i></span>';
                html += '<span class="vent-ets-node-label ets-label-depth-' + Math.min(depth, 2) + '">' + escapeHtml(node.name) + '</span>';
                if (node.code) html += '<span class="vent-ets-node-code">' + escapeHtml(node.code) + '</span>';
                if (sel) html += '<i class="far fa-check vent-ets-check"></i>';
                html += '</div>';
                return html;
            }

            function openDropdown() {
                $dropdown.show();
                $field.addClass('is-open');
                $field.find('.vent-ets-chevron').addClass('rotated');
                $search.val('');
                renderTree();
                setTimeout(function() { $search.focus(); }, 50);
            }

            function closeDropdown() {
                $dropdown.hide();
                $field.removeClass('is-open');
                $field.find('.vent-ets-chevron').removeClass('rotated');
            }

            function toggleDropdown() {
                if ($dropdown.is(':visible')) closeDropdown(); else openDropdown();
            }

            function selectEmplacement(empId) {
                $hidden.val(empId);
                renderField();
                closeDropdown();
            }

            function clearSelection(e) {
                if (e) e.stopPropagation();
                $hidden.val('');
                renderField();
            }

            $field.on('click', function(e) {
                if ($(e.target).closest('.vent-ets-clear-btn').length) return;
                toggleDropdown();
            });

            $field.on('keydown', function(e) {
                if (e.keyCode === 13 || e.keyCode === 32) { e.preventDefault(); toggleDropdown(); }
                if (e.keyCode === 27) closeDropdown();
            });

            $clearBtn.on('click', clearSelection);

            $search.on('input', renderTree);

            $search.on('keydown', function(e) {
                if (e.keyCode === 27) closeDropdown();
            });

            $treeList.on('click', '.vent-ets-node', function(e) {
                if ($(e.target).closest('.vent-ets-toggle').length) return;
                var empId = $(this).data('emp-id');
                selectEmplacement(empId);
            });

            $treeList.on('click', '.vent-ets-toggle', function(e) {
                e.stopPropagation();
                var nodeId = $(this).data('toggle-id');
                expandedNodes[nodeId] = !expandedNodes[nodeId];
                renderTree();
            });

            $(document).on('click', function(e) {
                if (!$(e.target).closest($widget).length) closeDropdown();
            });

            renderField();

            return {
                val: function(newVal) {
                    if (newVal !== undefined) { $hidden.val(newVal); renderField(); }
                    return $hidden.val();
                },
                reset: function() { clearSelection(); }
            };
        }

        function initVentRow($row, qtyInput) {
            var hasSn = $row.data('has-sn');
            var prefix = $row.data('prefix');
            var rowId = $row.attr('id');
            var $content = $row.find('.vent-content');
            var existingVents = $(qtyInput).data('existing-vents') || [];
            var vents = [];

            var html = '';
            html += '<div class="vent-saisie d-flex align-items-center mb-2" style="gap: 6px;">';
            if (hasSn) {
                html += '<div style="flex: 0 0 220px;">';
                html += '<div class="input-group input-group-sm">';
                html += '<input type="text" class="form-control vent-saisie-sn" id="saisie-sn-' + rowId + '" placeholder="Numéro de série">';
                html += '<div class="input-group-append">';
                html += '<button type="button" class="ix-btn ix-btn-icon blue barcode-trigger" data-target-input-id="saisie-sn-' + rowId + '"><i class="far fa-barcode-read"></i></button>';
                html += '</div></div></div>';
            } else {
                html += '<div style="flex: 0 0 220px;">';
                html += '<div class="input-group input-group-sm">';
                html += '<input type="number" step="0.001" class="form-control text-center vent-saisie-qty" placeholder="Quantité" min="0">';
                html += '<div class="input-group-append">';
                html += '<span class="input-group-text"><i class="far fa-layer-group"></i></span>';
                html += '</div></div></div>';
            }
            html += '<div style="flex: 1;">' + buildEmplacementWidget('') + '</div>';
            html += '<button type="button" class="ix-btn ix-btn-small blue js-vent-add" style="white-space: nowrap;"><i class="far fa-plus mr-1"></i> Ajouter</button>';
            html += '</div>';

            html += '<div class="vent-error text-danger small mb-1" style="display:none;"></div>';
            html += '<div class="vent-counter small mb-1"></div>';
            html += '<div class="vent-recap"></div>';
            html += '<div class="vent-hidden-inputs"></div>';

            $content.html(html);
            var empWidget = initEmplacementWidget($content.find('.vent-ets'));

            function getMaxQty() {
                return Math.floor(parseFloat(qtyInput.value) || 0);
            }

            function showError(msg) {
                var $err = $content.find('.vent-error');
                if (msg) {
                    $err.html('<i class="far fa-exclamation-triangle mr-1"></i>' + msg).show();
                } else {
                    $err.hide();
                }
            }

            function fmtNum(n) {
                return parseFloat(n.toFixed(3)).toString();
            }

            // Pré-remplit la quantité de ventilation avec le reste à ventiler (= qté réceptionnée tant que rien n'est ventilé)
            function syncSaisieQty() {
                if (hasSn) return;
                var totalVent = vents.reduce(function(sum, v) { return sum + (parseFloat(v.quantity) || 0); }, 0);
                var remaining = getMaxQty() - totalVent;
                $content.find('.vent-saisie-qty').val(remaining > 0 ? fmtNum(remaining) : '');
            }

            function renderRecap() {
                var $recap = $content.find('.vent-recap');
                var $counter = $content.find('.vent-counter');
                var max = getMaxQty();

                if (vents.length === 0) {
                    $recap.html('<div class="text-muted small py-1"><i class="far fa-info-circle mr-1"></i>Aucune ventilation saisie.</div>');
                    if (hasSn) {
                        $counter.html('<span class="text-muted"><i class="far fa-circle mr-1"></i>0 / ' + max + ' numéro(s) saisi(s)</span>');
                    } else {
                        $counter.html('<span class="text-muted"><i class="far fa-circle mr-1"></i>0 / ' + max + ' ventilé(s)</span>');
                    }
                    updateHiddenInputs();
                    return;
                }

                var snErrorValues = (window.__snErrorValues || []).map(function(v) { return v.toLowerCase(); });
                var hasErrors = snErrorValues.length > 0;

                var recapHtml = '<div class="list-group mb-0">';
                vents.forEach(function(vent, i) {
                    var isErrored = hasSn && hasErrors && snErrorValues.indexOf(vent.serial_number.toLowerCase()) !== -1;
                    var itemClass = 'list-group-item list-group-item-action py-1 px-2 d-flex align-items-center justify-content-between';
                    if (isErrored) {
                        itemClass += ' vent-item-error';
                    }
                    recapHtml += '<div class="' + itemClass + '">';
                    recapHtml += '<div class="d-flex align-items-center" style="gap: 8px;">';
                    recapHtml += '<span class="badge badge-light">' + (i + 1) + '</span>';
                    if (hasSn) {
                        var snClass = 'font-weight-bold' + (isErrored ? ' text-danger' : '');
                        recapHtml += '<span class="' + snClass + '">' + escapeHtml(vent.serial_number) + '</span>';
                    } else {
                        recapHtml += '<span class="font-weight-bold">' + escapeHtml(vent.quantity) + '</span>';
                    }
                    recapHtml += '<i class="far fa-arrow-right text-muted small"></i>';
                    recapHtml += '<span>' + escapeHtml(getEmplacementName(vent.emplacement_id)) + '</span>';
                    recapHtml += '</div>';
                    recapHtml += '<button type="button" class="ix-btn ix-btn-icon transparent js-vent-remove" data-idx="' + i + '" style="color:#ef4444;"><i class="fal fa-times"></i></button>';
                    recapHtml += '</div>';
                });
                recapHtml += '</div>';
                $recap.html(recapHtml);

                // Show error messages if any
                if (hasErrors && window.__snErrorMessages && window.__snErrorMessages.length > 0) {
                    var errHtml = '<div class="text-danger small mt-1">';
                    window.__snErrorMessages.forEach(function(msg) {
                        errHtml += '<div><i class="far fa-exclamation-circle mr-1"></i>' + escapeHtml(msg) + '</div>';
                    });
                    errHtml += '</div>';
                    $recap.append(errHtml);
                }

                if (hasSn) {
                    var cls = vents.length >= max ? 'text-success' : 'text-muted';
                    $counter.html('<span class="' + cls + '"><i class="far fa-check-circle mr-1"></i>' + vents.length + ' / ' + max + ' numéro(s) saisi(s)</span>');
                } else {
                    var totalVent = vents.reduce(function(sum, v) { return sum + (parseFloat(v.quantity) || 0); }, 0);
                    var remaining = max - totalVent;
                    var badgeClass = remaining === 0 ? 'text-success' : (remaining > 0 ? 'text-warning' : 'text-danger');
                    $counter.html('<span class="' + badgeClass + '"><i class="far fa-check-circle mr-1"></i>' + fmtNum(totalVent) + ' / ' + max + ' ventilé(s) — reste ' + fmtNum(remaining) + '</span>');
                }

                updateHiddenInputs();
            }

            function updateHiddenInputs() {
                var $hidden = $content.find('.vent-hidden-inputs');
                var html = '';
                vents.forEach(function(vent, i) {
                    if (hasSn) {
                        html += '<input type="hidden" name="' + prefix + '[' + i + '][serial_number]" value="' + escapeHtml(vent.serial_number) + '">';
                    } else {
                        html += '<input type="hidden" name="' + prefix + '[' + i + '][quantity]" value="' + escapeHtml(vent.quantity) + '">';
                    }
                    html += '<input type="hidden" name="' + prefix + '[' + i + '][emplacement_id]" value="' + vent.emplacement_id + '">';
                });
                $hidden.html(html);
            }

            function clearServerErrors() {
                window.__snErrorValues = [];
                window.__snErrorMessages = [];
            }

            function addVent() {
                showError('');
                clearServerErrors();
                var max = getMaxQty();
                if (max <= 0) {
                    showError('Saisissez d\'abord une quantité réceptionnée.');
                    return;
                }

                var empId = empWidget.val();
                if (!empId) {
                    showError('Sélectionnez une zone de stockage.');
                    return;
                }

                if (hasSn) {
                    var sn = $content.find('.vent-saisie-sn').val().trim();
                    if (!sn) {
                        showError('Saisissez un numéro de série.');
                        return;
                    }
                    var snLower = sn.toLowerCase();
                    var localDuplicate = vents.some(function(v) { return v.serial_number.toLowerCase() === snLower; });
                    if (localDuplicate) {
                        showError('Ce numéro de série est déjà saisi pour cet article.');
                        return;
                    }
                    if (__globalSnRegistry[snLower]) {
                        showError('Ce numéro de série est déjà ventilé sur un autre article.');
                        return;
                    }
                    if (vents.length >= max) {
                        showError('Maximum atteint : ' + max + ' numéro(s) de série (quantité réceptionnée).');
                        return;
                    }
                    vents.push({ serial_number: sn, emplacement_id: empId });
                    __globalSnRegistry[snLower] = true;
                    $content.find('.vent-saisie-sn').val('');
                    $content.find('.vent-saisie-sn').focus();
                    renderRecap();
                } else {
                    var qty = parseFloat($content.find('.vent-saisie-qty').val()) || 0;
                    if (qty <= 0) {
                        showError('Saisissez une quantité supérieure à 0.');
                        return;
                    }
                    var totalVent = vents.reduce(function(sum, v) { return sum + (parseFloat(v.quantity) || 0); }, 0);
                    if (totalVent + qty > max) {
                        showError('La quantité dépasse le reste à ventiler (' + fmtNum(max - totalVent) + ').');
                        return;
                    }
                    vents.push({ quantity: qty, emplacement_id: empId });
                    syncSaisieQty();
                    $content.find('.vent-saisie-qty').focus();
                    renderRecap();
                }
            }

            $content.on('click', '.js-vent-add', function(e) {
                e.preventDefault();
                addVent();
            });

            $content.on('click', '.js-vent-remove', function() {
                var idx = parseInt($(this).data('idx'));
                if (hasSn && vents[idx]) {
                    var snLower = vents[idx].serial_number.toLowerCase();
                    delete __globalSnRegistry[snLower];
                }
                vents.splice(idx, 1);
                clearServerErrors();
                renderRecap();
                syncSaisieQty();
            });

            $content.on('keydown', '.vent-saisie-sn, .vent-saisie-qty', function(e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    addVent();
                }
            });

            $(qtyInput).on('input', syncSaisieQty);

            $(qtyInput).on('change', function() {
                var max = getMaxQty();
                if (hasSn && vents.length > max) {
                    for (var i = max; i < vents.length; i++) {
                        delete __globalSnRegistry[vents[i].serial_number.toLowerCase()];
                    }
                    vents = vents.slice(0, max);
                } else if (!hasSn) {
                    var totalVent = vents.reduce(function(sum, v) { return sum + (parseFloat(v.quantity) || 0); }, 0);
                    if (totalVent > max) {
                        vents = [];
                    }
                }
                renderRecap();
                syncSaisieQty();
            });

            if (existingVents.length > 0) {
                existingVents.forEach(function(vent) {
                    var sn = vent.serial_number || '';
                    var empId = vent.emplacement_id || '';
                    var qty = vent.quantity || '';
                    if (hasSn && sn) {
                        vents.push({ serial_number: sn, emplacement_id: empId });
                    } else if (!hasSn && qty) {
                        vents.push({ quantity: qty, emplacement_id: empId });
                    }
                });
            }

            renderRecap();
            syncSaisieQty();

            $row.data('vent-apply-emplacement', function(empId) {
                empWidget.val(empId);
            });

            $row.data('vent-is-complete', function() {
                var max = getMaxQty();
                if (max <= 0) return true;
                if (hasSn) {
                    return vents.length >= max;
                } else {
                    var totalVent = vents.reduce(function(sum, v) { return sum + (parseFloat(v.quantity) || 0); }, 0);
                    return Math.abs(totalVent - max) < 0.001;
                }
            });

            $row.data('vent-get-status', function() {
                var max = getMaxQty();
                if (max <= 0) return { complete: true, max: 0, current: 0 };
                if (hasSn) {
                    return { complete: vents.length >= max, max: max, current: vents.length, hasSn: true };
                } else {
                    var totalVent = vents.reduce(function(sum, v) { return sum + (parseFloat(v.quantity) || 0); }, 0);
                    return { complete: Math.abs(totalVent - max) < 0.001, max: max, current: parseFloat(totalVent.toFixed(3)), hasSn: false };
                }
            });
        }

        window.applyGlobalEmplacement = function() {
            var globalEmpId = $('[name="global_emplacement_id"]').val();
            if (!globalEmpId) return;
            $('.vent-row').each(function() {
                var fn = $(this).data('vent-apply-emplacement');
                if (fn) fn(globalEmpId);
            });
        };

        __emplacementsPromise.then(function() {
            $('.js-reception-qty').each(function() {
                var containerId = $(this).data('vent-container');
                var $row = $('#' + containerId);
                if ($row.length) {
                    initVentRow($row, this);
                }
            });

            var defaultEmp = (__emplacementsData || []).find(function(e) { return e.is_default; });
            if (defaultEmp) {
                $('.vent-row').each(function() {
                    var fn = $(this).data('vent-apply-emplacement');
                    if (fn) fn(defaultEmp.id);
                });
            }
        });
    }

    initReceptionVentilation();

    // Serial numbers filter for article show view
    window.snShowOutVisible = false;

    window.toggleOutSerialNumbers = function() {
        window.snShowOutVisible = !window.snShowOutVisible;
        window.filterSerialNumbers();
    };

    window.filterSerialNumbers = function() {
        var input = document.getElementById('snShowSearch');
        if (!input) return;
        var term = input.value.toLowerCase().trim();
        var showOut = window.snShowOutVisible;
        var cards = document.querySelectorAll('#snShowGrid .sn-show-card');
        var visibleCount = 0;
        cards.forEach(function(card) {
            var isOut = card.dataset.isOut === '1';
            if (isOut && !showOut) {
                card.style.display = 'none';
                return;
            }
            var match = card.dataset.snValue.indexOf(term) !== -1;
            card.style.display = match ? '' : 'none';
            if (match) visibleCount++;
        });
        var emptyEl = document.getElementById('snShowEmpty');
        var gridEl = document.getElementById('snShowGrid');
        if (emptyEl) emptyEl.style.display = visibleCount === 0 ? '' : 'none';
        if (gridEl) gridEl.style.display = visibleCount === 0 ? 'none' : '';
    };

    // Run filter on page load to hide "out" SNs and show empty state if needed
    if (document.getElementById('snShowContainer')) {
        window.filterSerialNumbers();
    }

    // Stock events timeline — infinite scroll via IntersectionObserver
    var timelineScroll = document.getElementById('stockTimelineScroll');
    if (timelineScroll) {
        var loadingMore = false;
        var loader = document.getElementById('stockTimelineLoader');
        var timeline = document.getElementById('stockTimeline');

        function loadMoreStockEvents() {
            if (loadingMore) return;
            if (timelineScroll.dataset.hasMore !== '1') return;

            loadingMore = true;
            if (loader) loader.style.display = '';

            var offset = parseInt(timelineScroll.dataset.offset, 10) || 0;
            var articleId = timelineScroll.dataset.articleId;

            fetch('/stocks/articles/' + articleId + '/stock-events?offset=' + offset, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
                .then(function(res) { return res.json(); })
                .then(function(data) {
                    if (data.success && data.html) {
                        timeline.insertAdjacentHTML('beforeend', data.html);
                        timelineScroll.dataset.offset = data.offset;
                        timelineScroll.dataset.hasMore = data.has_more ? '1' : '0';
                    }
                    if (loader) loader.style.display = 'none';
                    loadingMore = false;
                })
                .catch(function() {
                    if (loader) loader.style.display = 'none';
                    loadingMore = false;
                });
        }

        // Scroll-based infinite loading
        timelineScroll.addEventListener('scroll', function() {
            if (this.scrollTop + this.clientHeight >= this.scrollHeight - 50) {
                loadMoreStockEvents();
            }
        });
    }

    // Recomptage - soumission du modal selon le périmètre choisi
    $('#recountSubmitBtn').on('click', function() {
        var scope = $('input[name="recount_scope"]:checked').val();
        var form = $('#recountForm');
        if (scope === 'all') {
            form.attr('action', form.data('route-all'));
        } else {
            form.attr('action', form.data('route-discrepancies'));
        }
        form.submit();
    });

    // Recomptage - changement de mode via modal sur la page de recomptage
    $('#recountModeSubmitBtn').on('click', function() {
        var scope = $('input[name="recount_scope"]:checked').val();
        var mode = $('input[name="recount_mode"]:checked').val();
        var routeDiscrepancies = $(this).data('route-discrepancies');
        var routeAll = $(this).data('route-all');

        var form = $('<form method="POST" action="' + (scope === 'all' ? routeAll : routeDiscrepancies) + '">' +
            '<input type="hidden" name="_token" value="' + CSRF_TOKEN + '">' +
            '<input type="hidden" name="recount_mode" value="' + mode + '">' +
            '</form>');
        $('body').append(form);
        form.submit();
    });
});
window.limitTextarea = function(el, maxLines, maxCharsPerLine) {
    el.addEventListener('input', function() {
        var lines = el.value.split('\n');
        var newLines = [];
        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            while (line.length > maxCharsPerLine && newLines.length < maxLines) {
                newLines.push(line.substring(0, maxCharsPerLine));
                line = line.substring(maxCharsPerLine);
            }
            if (newLines.length < maxLines) {
                newLines.push(line);
            }
        }
        if (newLines.length > maxLines) {
            newLines = newLines.slice(0, maxLines);
        }
        el.value = newLines.join('\n');
    });
    el.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            var lines = el.value.split('\n');
            if (lines.length >= maxLines) {
                e.preventDefault();
                return false;
            }
        }
    });
};
